import React, { useState, useEffect, useContext } from 'react'
import { AuthContext } from '../../Context'
import { AuthContextApi } from '../../Context/api'
import { toast } from 'react-toastify'
import './index.css'
import {
    PlusIcon,
    MagnifyingGlassIcon,
    XMarkIcon,
    ChevronLeftIcon,
    ChevronRightIcon,
    ChevronDownIcon,
    ChevronUpIcon,
    TruckIcon,
    UserIcon,
    MapPinIcon,
    CalendarIcon,
    PhotoIcon,
    InformationCircleIcon,
    BuildingOfficeIcon,
    ArchiveBoxIcon,
    EyeIcon,
    ArrowUpIcon,
    ArrowDownIcon,
    ArrowsRightLeftIcon,
    ArrowUturnLeftIcon,
    ChartBarIcon,
    BarsArrowUpIcon,
    BarsArrowDownIcon,
    PencilSquareIcon,
    EnvelopeIcon
} from '@heroicons/react/24/outline'
import { jsonConfig } from '../../Config'
import ZoomableImageModal from '../../Components/ZoomableImageModal'


const Movimentacoes = () => {
    const { states, setters } = useContext(AuthContext)
    const { getMovimentacoes, getMovimentacaoId, createMovimentacao, getEntidades, getProdutosCadastro, getMovimentacoesEntidade,
        returnMovimentacoes, cancelMovimentacoes, getLocalizacoes, getDepartamentos, getLocalizacoesProprietario, putMovimentacoes,
        getUsuarios,
        exportarListaEmail
    } = useContext(AuthContextApi)

    // Estados locais
    const [searchTerm, setSearchTerm] = useState('')
    const [selectedFilterField, setSelectedFilterField] = useState('produto_codigo_net')
    const [selectedSortField, setSelectedSortField] = useState('produto_codigo_net')
    const [sortDirection, setSortDirection] = useState('desc')
    const [recordsPerPage, setRecordsPerPage] = useState(10)
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [isEditMode, setIsEditMode] = useState(false)
    const [selectedMovimentacao, setSelectedMovimentacao] = useState(null)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [isViewModalOpen, setIsViewModalOpen] = useState(false)
    const [viewingMovimentacao, setViewingMovimentacao] = useState(null)
    const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false)
    const [confirmAction, setConfirmAction] = useState(null)
    const [confirmMessage, setConfirmMessage] = useState('')
    const [confirmTitle, setConfirmTitle] = useState('')
    const [confirmIcon, setConfirmIcon] = useState(null)
    const [confirmButtonText, setConfirmButtonText] = useState('')
    const [confirmButtonColor, setConfirmButtonColor] = useState('')
    const [selectedMovimentacaoForAction, setSelectedMovimentacaoForAction] = useState(null)
    const [idsSelecionados, setIdsSelecionados] = useState([])
    const [isExportModalOpen, setIsExportModalOpen] = useState(false)
    const emailUsuario = localStorage.getItem('usuario') || ''

    // Estados para modal de edição
    const [isEditModalOpen, setIsEditModalOpen] = useState(false)
    const [editMovimentacao, setEditMovimentacao] = useState(null)
    const [editLocalizacaoId, setEditLocalizacaoId] = useState('')
    const [editDepartamentoId, setEditDepartamentoId] = useState('')
    const [editResponsavelEntrega, setEditResponsavelEntrega] = useState('')
    const [editEmailResponsavelEntrega, setEditEmailResponsavelEntrega] = useState('')
    const [editObservacao, setEditObservacao] = useState('')
    const [isSubmittingEdit, setIsSubmittingEdit] = useState(false)
    const [loadingEditData, setLoadingEditData] = useState(false)

    // Estados para selects do modal de edição
    const [editLocalizacoes, setEditLocalizacoes] = useState([])
    const [editDepartamentos, setEditDepartamentos] = useState([])
    const [loadingEditLocalizacoes, setLoadingEditLocalizacoes] = useState(false)
    const [loadingEditDepartamentos, setLoadingEditDepartamentos] = useState(false)

    // Estados para imagens da edição
    const [editFoto1, setEditFoto1] = useState(null)
    const [editFoto2, setEditFoto2] = useState(null)
    const [editFoto3, setEditFoto3] = useState(null)
    const [editPreviewFoto1, setEditPreviewFoto1] = useState('')
    const [editPreviewFoto2, setEditPreviewFoto2] = useState('')
    const [editPreviewFoto3, setEditPreviewFoto3] = useState('')
    const [editFoto1Alterada, setEditFoto1Alterada] = useState(false)
    const [editFoto2Alterada, setEditFoto2Alterada] = useState(false)
    const [editFoto3Alterada, setEditFoto3Alterada] = useState(false)

    // Estados para busca de usuários
    const [isSearchingUsuario, setIsSearchingUsuario] = useState(false)
    const [usuarioSearchTerm, setUsuarioSearchTerm] = useState('')
    const [usuarioSearchResults, setUsuarioSearchResults] = useState([])
    const [selectedUsuario, setSelectedUsuario] = useState(null)
    const [isUsuarioDropdownOpen, setIsUsuarioDropdownOpen] = useState(false)
    const [loadingUsuarioSearch, setLoadingUsuarioSearch] = useState(false)

    // Estados para busca por cliente
    const [clientSearchTerm, setClientSearchTerm] = useState('')
    const [clientSearchResults, setClientSearchResults] = useState([])
    const [selectedClient, setSelectedClient] = useState(null)
    const [isClientDropdownOpen, setIsClientDropdownOpen] = useState(false)
    const [loadingClientSearch, setLoadingClientSearch] = useState(false)

    // Estados para modal de retorno
    const [isReturnModalOpen, setIsReturnModalOpen] = useState(false)
    const [returnMovimentacao, setReturnMovimentacao] = useState(null)
    const [returnLocalizacaoId, setReturnLocalizacaoId] = useState('')
    const [returnDepartamentoId, setReturnDepartamentoId] = useState('')
    const [returnObservacao, setReturnObservacao] = useState('')
    const [isSubmittingReturn, setIsSubmittingReturn] = useState(false)
    const [loadingReturnData, setLoadingReturnData] = useState(false)

    // Estados para modal de seleção de produtos
    const [productSearchTerm, setProductSearchTerm] = useState('')
    const [selectedProduct, setSelectedProduct] = useState(null)

    // Estado para controlar movimentação interna
    const [isInternalMovement, setIsInternalMovement] = useState(false)

    // Estados para selects do modal de retorno
    const [returnLocalizacoes, setReturnLocalizacoes] = useState([])
    const [returnDepartamentos, setReturnDepartamentos] = useState([])
    const [loadingReturnLocalizacoes, setLoadingReturnLocalizacoes] = useState(false)
    const [loadingReturnDepartamentos, setLoadingReturnDepartamentos] = useState(false)

    // Estados para imagens do retorno
    const [returnFoto1, setReturnFoto1] = useState(null)
    const [returnFoto2, setReturnFoto2] = useState(null)
    const [returnFoto3, setReturnFoto3] = useState(null)
    const [returnPreviewFoto1, setReturnPreviewFoto1] = useState('')
    const [returnPreviewFoto2, setReturnPreviewFoto2] = useState('')
    const [returnPreviewFoto3, setReturnPreviewFoto3] = useState('')

    // Estados para modal de imagem expandida
    const [isImageModalOpen, setIsImageModalOpen] = useState(false)
    const [expandedImage, setExpandedImage] = useState('')
    const [expandedImageAlt, setExpandedImageAlt] = useState('')

    // Estados do formulário
    const [produtoId, setProdutoId] = useState('')
    const [entidadeId, setEntidadeId] = useState('')
    const [localizacaoId, setLocalizacaoId] = useState('')
    const [departamentoId, setDepartamentoId] = useState('')
    const [responsavelEntrega, setResponsavelEntrega] = useState('')
    const [emailResponsavelEntrega, setEmailResponsavelEntrega] = useState('')
    const [observacao, setObservacao] = useState('')

    // Estados para selects
    const [produtos, setProdutos] = useState([])
    const [entidades, setEntidades] = useState([])
    const [localizacoes, setLocalizacoes] = useState([])
    const [departamentos, setDepartamentos] = useState([])
    const [loadingSelects, setLoadingSelects] = useState(false)
    const [loadingLocalizacoes, setLoadingLocalizacoes] = useState(false)
    const [loadingDepartamentos, setLoadingDepartamentos] = useState(false)

    // Estados para busca paginada de cliente no cadastro de movimentação
    const [destinoClienteTerm, setDestinoClienteTerm] = useState('')
    const [destinoClienteResults, setDestinoClienteResults] = useState([])
    const [destinoClienteSelected, setDestinoClienteSelected] = useState(null)
    const [isDestinoClienteDropdownOpen, setIsDestinoClienteDropdownOpen] = useState(false)
    const [loadingDestinoCliente, setLoadingDestinoCliente] = useState(false)
    const [destinoClientePage, setDestinoClientePage] = useState(0)
    const [destinoClienteHasMore, setDestinoClienteHasMore] = useState(true)

    // Estados para imagens
    const [foto1, setFoto1] = useState(null)
    const [foto2, setFoto2] = useState(null)
    const [foto3, setFoto3] = useState(null)
    const [previewFoto1, setPreviewFoto1] = useState('')
    const [previewFoto2, setPreviewFoto2] = useState('')
    const [previewFoto3, setPreviewFoto3] = useState('')

    // Opções de filtro
    const filterOptions = [
        { value: 'cliente', label: 'Cliente' },
        { value: 'produto_codigo_net', label: 'Código Net' },
        { value: 'equipamento_nome', label: 'Equipamento' },
        { value: 'equipamento_formato_nome', label: 'Equipamento Formato' },
        { value: 'modelo', label: 'Nome' },
        { value: 'produto_serial', label: 'Número de Série' },
        { value: 'movimentacao_usuario', label: 'Usuário responsável' },
    ]

    // Opções de ordenação
    const sortOptions = [
        { value: 'produto_codigo_net', label: 'Código Net' },
        { value: 'data_atualizacao', label: 'Data de Atualização' },
        { value: 'data_criacao', label: 'Data de Criação' }
    ]

    // Tipos de movimentação com ícones modernos
    const tiposMovimentacao = [
        { value: 0, label: 'Enviado', color: 'bg-gradient-to-r from-green-500 to-emerald-500', icon: ArrowUpIcon, bgColor: 'from-green-50 to-emerald-50', textColor: 'text-green-700' },
        { value: 1, label: 'Retorno', color: 'bg-gradient-to-r from-blue-500 to-indigo-500', icon: ArrowDownIcon, bgColor: 'from-blue-50 to-indigo-50', textColor: 'text-blue-700' },
        { value: 2, label: 'Encerrada', color: 'bg-gradient-to-r from-yellow-500 to-orange-500', icon: ArrowUturnLeftIcon, bgColor: 'from-yellow-50 to-orange-50', textColor: 'text-yellow-700' },
        { value: 3, label: 'Cancelada', color: 'bg-gradient-to-r from-red-500 to-pink-500', icon: ArrowDownIcon, bgColor: 'from-yellow-50 to-orange-50', textColor: 'text-yellow-700' }
    ]

    // Função para carregar movimentações
    const loadMovimentacoes = async () => {
        let searchValue = searchTerm || ''
        let filterField = selectedFilterField

        // Se o filtro for usuário e há um usuário selecionado, usar busca por email
        if (selectedFilterField === 'movimentacao_usuario' && selectedUsuario) {
            filterField = 'movimentacao_usuario'
            searchValue = selectedUsuario.email
        }

        const query = new URLSearchParams({
            page: states.page || 0,
            per_page: recordsPerPage,
            sort: selectedSortField,
            sort_dir: sortDirection,
            filter: filterField,
            search: searchValue
        }).toString()

        if (selectedFilterField === 'cliente') {
            if (!selectedClient) return
            const queryCliente = new URLSearchParams({
                page: states.page || 0,
                per_page: recordsPerPage,
                sort: selectedSortField,
                sort_dir: sortDirection
            }).toString()
            await getMovimentacoesEntidade(queryCliente, selectedClient.id)
            return
        }

        await getMovimentacoes(query)
    }

    // Função para carregar dados dos selects
    const loadSelectData = async () => {
        setLoadingSelects(true)
        try {
            // Carregar produtos com flag de disponibilidade
            const produtosQuery = new URLSearchParams({
                per_page: 1000,
                sort: 'modelo',
                sort_dir: 'asc',
                disponivel_movimentacao: 'all' // Buscar todos os produtos
            }).toString()
            const produtosResult = await getProdutosCadastro(produtosQuery)

            if (produtosResult && Array.isArray(produtosResult)) {
                setProdutos([...produtosResult].sort((a, b) => String(a.modelo || '').localeCompare(String(b.modelo || ''), 'pt-BR')))
            }

        } catch (error) {
            console.error('Erro ao carregar dados dos selects:', error)
            toast.error('Erro ao carregar dados dos selects')
        } finally {
            setLoadingSelects(false)
        }
    }

    // Função para buscar usuários
    const searchUsuarios = async (searchTerm) => {
        if (!searchTerm || searchTerm.trim().length < 2) {
            setUsuarioSearchResults([])
            setIsUsuarioDropdownOpen(false)
            return
        }

        setLoadingUsuarioSearch(true)
        try {
            const query = new URLSearchParams({
                filter: 'nome',
                search: searchTerm.trim(),
                per_page: 100
            }).toString()

            const result = await getUsuarios(query)
            if (result) {
                setUsuarioSearchResults(Array.isArray(result) ? [...result].sort((a, b) => String(a.nome || '').localeCompare(String(b.nome || ''), 'pt-BR')) : result)
                setIsUsuarioDropdownOpen(true)
            } else {
                setUsuarioSearchResults([])
                setIsUsuarioDropdownOpen(false)
            }
        } catch (error) {
            toast.error('Erro ao buscar usuários')
            setUsuarioSearchResults([])
            setIsUsuarioDropdownOpen(false)
        } finally {
            setLoadingUsuarioSearch(false)
        }
    }

    // Função para selecionar usuário
    const selectUsuario = (usuario) => {
        setSelectedUsuario(usuario)
        setUsuarioSearchTerm(usuario.nome)
        setIsUsuarioDropdownOpen(false)
        setUsuarioSearchResults([])

        // Resetar página para 0 e realizar busca automática
        if (setters.setPage) {
            setters.setPage(0)
        }
        loadMovimentacoes()
    }

    // Função para limpar seleção de usuário
    const clearUsuarioSelection = () => {
        setSelectedUsuario(null)
        setUsuarioSearchTerm('')
        setUsuarioSearchResults([])
        setIsUsuarioDropdownOpen(false)

        // Recarregar movimentações com parâmetros normais
        if (setters.setPage) {
            setters.setPage(0)
        }
        loadMovimentacoes()
    }

    // Função para buscar clientes/entidades
    const searchClients = async (searchTerm) => {
        if (!searchTerm || searchTerm.trim().length < 2) {
            setClientSearchResults([])
            setIsClientDropdownOpen(false)
            return
        }

        setLoadingClientSearch(true)
        try {
            const query = new URLSearchParams({
                filter: 'nome',
                search: searchTerm.trim(),
                per_page: 100
            }).toString()

            const result = await getEntidades(query)
            if (result) {
                setClientSearchResults(Array.isArray(result) ? [...result].sort((a, b) => String(a.nome || '').localeCompare(String(b.nome || ''), 'pt-BR')) : result)
                setIsClientDropdownOpen(true)
            } else {
                setClientSearchResults([])
                setIsClientDropdownOpen(false)
            }
        } catch (error) {
            toast.error('Erro ao buscar clientes')
            setClientSearchResults([])
            setIsClientDropdownOpen(false)
        } finally {
            setLoadingClientSearch(false)
        }
    }

    // Função para selecionar cliente
    const selectClient = (client) => {
        setSelectedClient(client)
        setClientSearchTerm(client.nome)
        setIsClientDropdownOpen(false)
        setClientSearchResults([])

        if (setters.setPage) {
            setters.setPage(0)
        }
        const query = new URLSearchParams({
            page: 0,
            per_page: recordsPerPage,
            sort: selectedSortField,
            sort_dir: sortDirection
        }).toString()
        getMovimentacoesEntidade(query, client.id)
    }

    // Função para limpar seleção de cliente
    const clearClientSelection = () => {
        const tinhaCliente = !!selectedClient
        setSelectedClient(null)
        setClientSearchTerm('')
        setClientSearchResults([])
        setIsClientDropdownOpen(false)

        if (setters.setPage) {
            setters.setPage(0)
        }
        if (tinhaCliente) {
            const query = new URLSearchParams({
                page: 0,
                per_page: recordsPerPage,
                sort: selectedSortField,
                sort_dir: sortDirection,
                filter: selectedFilterField === 'cliente' ? 'produto_codigo_net' : selectedFilterField,
                search: selectedFilterField === 'cliente' ? '' : (searchTerm || '')
            }).toString()
            getMovimentacoes(query)
        }
    }

    const loadDestinoClientes = async (search, page, append) => {
        setLoadingDestinoCliente(true)
        try {
            const params = {
                page: page,
                per_page: 15,
                sort: 'nome',
                sort_dir: 'asc',
                tipo: '1',
                filter: 'nome'
            }
            if (search && search.trim()) {
                params.search = search.trim()
            }
            const query = new URLSearchParams(params).toString()
            const result = await getEntidades(query)
            if (result && Array.isArray(result) && result.length > 0) {
                const sorted = [...result].sort((a, b) => String(a.nome || '').localeCompare(String(b.nome || ''), 'pt-BR'))
                if (append) {
                    setDestinoClienteResults(prev => [...prev, ...sorted])
                } else {
                    setDestinoClienteResults(sorted)
                }
                setDestinoClientePage(page)
                setDestinoClienteHasMore(result.length >= 15)
                setIsDestinoClienteDropdownOpen(true)
            } else {
                if (!append) {
                    setDestinoClienteResults([])
                }
                setDestinoClienteHasMore(false)
                setIsDestinoClienteDropdownOpen(true)
            }
        } catch (error) {
            toast.error('Erro ao buscar clientes')
            if (!append) {
                setDestinoClienteResults([])
            }
            setDestinoClienteHasMore(false)
        } finally {
            setLoadingDestinoCliente(false)
        }
    }

    const selectDestinoCliente = (client) => {
        setDestinoClienteSelected(client)
        setDestinoClienteTerm(client.nome)
        setIsDestinoClienteDropdownOpen(false)
        setEntidadeId(client.id)
        loadLocalizacoes(client.id)
    }

    const clearDestinoCliente = () => {
        setDestinoClienteSelected(null)
        setDestinoClienteTerm('')
        setDestinoClienteResults([])
        setIsDestinoClienteDropdownOpen(false)
        setDestinoClientePage(0)
        setDestinoClienteHasMore(true)
        setEntidadeId('')
        setLocalizacaoId('')
        setDepartamentoId('')
        setLocalizacoes([])
        setDepartamentos([])
    }

    // Função para buscar produto pelo código NET
    const handleProductSearch = async () => {
        if (!productSearchTerm.trim()) {
            toast.error('Digite um código NET válido')
            return
        }

        const codigoNet = parseInt(productSearchTerm.trim())
        if (isNaN(codigoNet) || codigoNet <= 0) {
            toast.error('Digite um código NET válido (número inteiro positivo)')
            return
        }

        try {
            setLoadingSelects(true)
            const query = new URLSearchParams({
                per_page: 1000,
                filter: 'codigo_net',
                search: codigoNet
            }).toString()
            const result = await getProdutosCadastro(query)

            if (result && Array.isArray(result)) {
                const produto = result.find(p => p.codigo_net === codigoNet)

                if (produto) {
                    setSelectedProduct(produto)
                    setProdutoId(produto.id)
                    setProductSearchTerm('')
                    toast.success(`Produto encontrado: ${produto.modelo}`)
                } else {
                    toast.error(`Produto com código NET ${codigoNet} não encontrado`)
                }
            } else {
                toast.error('Erro ao buscar produtos')
            }
        } catch (error) {
            console.error('Erro ao buscar produto:', error)
            toast.error('Erro ao buscar produto')
        } finally {
            setLoadingSelects(false)
        }
    }

    // Função para carregar localizações baseada no produto selecionado
    const loadLocalizacoes = async (entidadeId) => {
        setLoadingLocalizacoes(true)
        try {
            const query = new URLSearchParams({
                per_page: 1000,
                sort: 'nome',
                sort_dir: 'asc'
            }).toString()

            let result

            // Se é movimentação interna, sempre busca localizações do proprietário
            if (isInternalMovement) {
                result = await getLocalizacoesProprietario(query)
            }
            // Se o produto pode mudar local, busca localizações da entidade selecionada
            else if (selectedProduct && selectedProduct.mudarLocal && entidadeId) {
                result = await getLocalizacoes(entidadeId, query)
            } else if (selectedProduct && !selectedProduct.mudarLocal) {
                // Se não pode mudar local, busca localizações do proprietário
                result = await getLocalizacoesProprietario(query)
            } else {
                setLocalizacoes([])
                setDepartamentos([])
                setLocalizacaoId('')
                setDepartamentoId('')
                return
            }

            if (result && Array.isArray(result)) {
                setLocalizacoes([...result].sort((a, b) => String(a.nome || '').localeCompare(String(b.nome || ''), 'pt-BR')))
            } else {
                setLocalizacoes([])
            }

            // Limpar departamentos e localização selecionada
            setDepartamentos([])
            setLocalizacaoId('')
            setDepartamentoId('')
        } catch (error) {
            console.error('Erro ao carregar localizações:', error)
            toast.error('Erro ao carregar localizações')
            setLocalizacoes([])
        } finally {
            setLoadingLocalizacoes(false)
        }
    }

    // Função para carregar departamentos da localização selecionada
    const loadDepartamentos = async (localizacaoId) => {
        if (!localizacaoId) {
            setDepartamentos([])
            setDepartamentoId('')
            return
        }

        setLoadingDepartamentos(true)
        try {
            const query = new URLSearchParams({
                per_page: 1000,
                sort: 'nome',
                sort_dir: 'asc'
            }).toString()

            const result = await getDepartamentos(localizacaoId, query)
            if (result && Array.isArray(result)) {
                setDepartamentos([...result].sort((a, b) => String(a.nome || '').localeCompare(String(b.nome || ''), 'pt-BR')))
            } else {
                setDepartamentos([])
            }

            // Limpar departamento selecionado
            setDepartamentoId('')
        } catch (error) {
            console.error('Erro ao carregar departamentos:', error)
            toast.error('Erro ao carregar departamentos')
            setDepartamentos([])
        } finally {
            setLoadingDepartamentos(false)
        }
    }

    // Função para buscar
    const handleSearch = () => {
        if (selectedFilterField === 'cliente' && !selectedClient) {
            toast.error('Selecione um cliente antes de buscar')
            return
        }

        setters.setPage(0)
        loadMovimentacoes()
    }

    // Função para limpar busca
    const handleClear = () => {
        setSearchTerm('')
        setSelectedFilterField('equipamento_formato_nome')
        setSelectedSortField('data_criacao')
        setSortDirection('desc')
        setSelectedUsuario(null)
        setUsuarioSearchTerm('')
        setUsuarioSearchResults([])
        setIsUsuarioDropdownOpen(false)
        setSelectedClient(null)
        setClientSearchTerm('')
        setClientSearchResults([])
        setIsClientDropdownOpen(false)
        setters.setPage(0)
        const query = new URLSearchParams({
            page: 0,
            per_page: recordsPerPage,
            sort: 'data_criacao',
            sort_dir: 'desc',
            filter: 'equipamento_formato_nome',
            search: ''
        }).toString()
        getMovimentacoes(query)
    }

    // Função para próxima página
    const handleNext = () => {
        setters.setPage(states.page + 1)
    }

    // Função para página anterior
    const handlePrevious = () => {
        if (states.page > 0) {
            setters.setPage(states.page - 1)
        }
    }

    // Função para abrir modal de visualização
    const openViewModal = async (movimentacao) => {
        try {
            const result = await getMovimentacaoId(movimentacao.movimentacao_id)
            if (result && result.data) {
                setViewingMovimentacao(result.data)
                setIsViewModalOpen(true)
            } else {
                toast.error('Erro ao carregar detalhes da movimentação')
            }
        } catch (error) {
            console.error('Erro ao carregar movimentação:', error)
            toast.error('Erro ao carregar detalhes da movimentação')
        }
    }

    // Função para abrir modal de edição
    const openEditModal = async (movimentacao) => {
        try {
            const result = await getMovimentacaoId(movimentacao.movimentacao_id)
            if (result && result.data) {
                const movimentacaoData = result.data
                const departamentoNomeAtual = movimentacaoData.departamento_nome || ''
                setEditMovimentacao({ ...movimentacaoData, departamento_nome: departamentoNomeAtual })

                // Preencher campos editáveis
                setEditLocalizacaoId(movimentacaoData.local_id || '')
                setEditDepartamentoId(movimentacaoData.departamento_id || '')
                setEditResponsavelEntrega(movimentacaoData.movimentacao_responsavel_entrega || '')
                setEditEmailResponsavelEntrega(movimentacaoData.movimentacao_email_responsavel_entrega || '')
                setEditObservacao(movimentacaoData.movimentacao_observacao || '')

                // Carregar localizações disponíveis
                await loadEditLocalizacoes(movimentacaoData.entidade_destino_id)

                // Carregar departamentos da localização atual
                if (movimentacaoData.local_id) {
                    await loadEditDepartamentos(movimentacaoData.local_id)
                }

                // Carregar fotos existentes se houver
                if (movimentacaoData.movimentacao_foto1) {
                    setEditPreviewFoto1(`/api/movimentacao/${movimentacaoData.movimentacao_foto1}`)
                }
                if (movimentacaoData.movimentacao_foto2) {
                    setEditPreviewFoto2(`/api/movimentacao/${movimentacaoData.movimentacao_foto2}`)
                }
                if (movimentacaoData.movimentacao_foto3) {
                    setEditPreviewFoto3(`/api/movimentacao/${movimentacaoData.movimentacao_foto3}`)
                }

                setIsEditModalOpen(true)
            }
        } catch (error) {
            toast.error('Erro ao carregar dados da movimentação para edição')
        }
    }

    // Função para fechar modal de edição
    const closeEditModal = () => {
        setIsEditModalOpen(false)
        setEditMovimentacao(null)
        setEditLocalizacaoId('')
        setEditDepartamentoId('')
        setEditResponsavelEntrega('')
        setEditEmailResponsavelEntrega('')
        setEditObservacao('')
        setEditFoto1(null)
        setEditFoto2(null)
        setEditFoto3(null)
        setEditPreviewFoto1('')
        setEditPreviewFoto2('')
        setEditPreviewFoto3('')
        setEditFoto1Alterada(false)
        setEditFoto2Alterada(false)
        setEditFoto3Alterada(false)
        setEditLocalizacoes([])
        setEditDepartamentos([])
    }

    // Função para carregar localizações para edição
    const loadEditLocalizacoes = async (entidade_id) => {
        setLoadingEditLocalizacoes(true)
        try {
            const query = new URLSearchParams({
                page: 0,
                per_page: 100
            }).toString()
            const response = await getLocalizacoes(entidade_id, query)
            if (response) {
                setEditLocalizacoes(Array.isArray(response) ? [...response].sort((a, b) => String(a.nome || '').localeCompare(String(b.nome || ''), 'pt-BR')) : response)
            }
        } catch (error) {
            toast.error('Erro ao carregar localizações')
        } finally {
            setLoadingEditLocalizacoes(false)
        }
    }

    // Função para carregar departamentos para edição
    const loadEditDepartamentos = async (localizacaoId) => {
        setLoadingEditDepartamentos(true)
        try {
            const query = new URLSearchParams({
                page: 0,
                per_page: 100
            }).toString()
            const response = await getDepartamentos(localizacaoId, query)
            if (response) {
                setEditDepartamentos(Array.isArray(response) ? [...response].sort((a, b) => String(a.nome || '').localeCompare(String(b.nome || ''), 'pt-BR')) : response)
            }
        } catch (error) {
            toast.error('Erro ao carregar departamentos')
        } finally {
            setLoadingEditDepartamentos(false)
        }
    }

    // Função para lidar com upload de imagem na edição
    const handleEditImageUpload = (file, setImage, setPreview, setFotoAlterada) => {
        if (file) {
            setImage(file)
            const reader = new FileReader()
            reader.onload = (e) => setPreview(e.target.result)
            reader.readAsDataURL(file)
            setFotoAlterada(true)
        }
    }

    // Função para salvar edição
    const handleSaveEdit = async () => {
        if (!editMovimentacao) return

        // Validações obrigatórias apenas para localização e departamento
        if (!editLocalizacaoId) {
            toast.error('Localização é obrigatória')
            return
        }
        if (!editDepartamentoId) {
            toast.error('Departamento é obrigatório')
            return
        }

        setIsSubmittingEdit(true)
        try {
            const formData = new FormData()
            formData.append('localizacao', editLocalizacaoId)
            formData.append('departamento', editDepartamentoId)
            formData.append('responsavel_entrega', editResponsavelEntrega)
            formData.append('email_responsavel_entrega', editEmailResponsavelEntrega)
            formData.append('observacao', editObservacao)

            // Flags das fotos
            formData.append('foto1', editFoto1Alterada)
            formData.append('foto2', editFoto2Alterada)
            formData.append('foto3', editFoto3Alterada)

            // Adicionar fotos alteradas
            if (editFoto1Alterada && editFoto1) {
                formData.append('images', editFoto1)
            }
            if (editFoto2Alterada && editFoto2) {
                formData.append('images', editFoto2)
            }
            if (editFoto3Alterada && editFoto3) {
                formData.append('images', editFoto3)
            }

            const success = await putMovimentacoes(formData, editMovimentacao.movimentacao_id)
            if (success) {
                toast.success('Movimentação atualizada com sucesso!')
                closeEditModal()
                loadMovimentacoes()
            }
        } catch (error) {
            toast.error('Erro ao atualizar movimentação')
        } finally {
            setIsSubmittingEdit(false)
        }
    }

    // Função para abrir modal de edição/criação
    const openModal = (movimentacao = null) => {
        setIsEditMode(!!movimentacao)
        setSelectedMovimentacao(movimentacao)

        if (movimentacao) {
            // Setar estados com dados da movimentação
            setProdutoId(movimentacao.produto_id || '')
            setEntidadeId(movimentacao.movimentacao_entidade_id || '')
            setLocalizacaoId(movimentacao.localizacao_id || '')
            setDepartamentoId(movimentacao.departamento_id || '')
            setResponsavelEntrega(movimentacao.movimentacao_responsavel_entrega || '')
            setEmailResponsavelEntrega(movimentacao.movimentacao_email_responsavel_entrega || '')
            setObservacao(movimentacao.movimentacao_observacao || '')

            // Setar previews das imagens em base64
            if (movimentacao.movimentacao_foto1_path && isValidBase64(movimentacao.movimentacao_foto1_path)) {
                setPreviewFoto1(createImageSrc(movimentacao.movimentacao_foto1_path))
            }
            if (movimentacao.movimentacao_foto2_path && isValidBase64(movimentacao.movimentacao_foto2_path)) {
                setPreviewFoto2(createImageSrc(movimentacao.movimentacao_foto2_path))
            }
            if (movimentacao.movimentacao_foto3_path && isValidBase64(movimentacao.movimentacao_foto3_path)) {
                setPreviewFoto3(createImageSrc(movimentacao.movimentacao_foto3_path))
            }
        } else {
            resetForm()
        }

        setIsModalOpen(true)
    }

    // Função para resetar formulário
    const resetForm = () => {
        setProdutoId('')
        setEntidadeId('')
        setLocalizacaoId('')
        setDepartamentoId('')
        setResponsavelEntrega('')
        setEmailResponsavelEntrega('')
        setObservacao('')
        setFoto1(null)
        setFoto2(null)
        setFoto3(null)
        setPreviewFoto1('')
        setPreviewFoto2('')
        setPreviewFoto3('')
        setLocalizacoes([])
        setDepartamentos([])
        setIsInternalMovement(false)
        setDestinoClienteTerm('')
        setDestinoClienteResults([])
        setDestinoClienteSelected(null)
        setIsDestinoClienteDropdownOpen(false)
        setDestinoClientePage(0)
        setDestinoClienteHasMore(true)
    }

    // Função para fechar modal
    const closeModal = () => {
        setIsModalOpen(false)
        setIsEditMode(false)
        setSelectedMovimentacao(null)
        resetForm()
        // Limpar estados específicos do produto
        setSelectedProduct(null)
        setProdutoId('')
        setProductSearchTerm('')
        // Limpar estados de localização
        setLocalizacoes([])
        setDepartamentos([])
        setLocalizacaoId('')
        setDepartamentoId('')
        setIsInternalMovement(false)
    }

    // Função para fechar modal de visualização
    const closeViewModal = () => {
        setIsViewModalOpen(false)
        setViewingMovimentacao(null)
    }

    // Função para abrir modal de imagem expandida
    const openImageModal = (imageSrc, imageAlt = 'Imagem da Movimentação') => {
        setExpandedImage(imageSrc)
        setExpandedImageAlt(imageAlt)
        setIsImageModalOpen(true)
    }

    // Função para fechar modal de imagem expandida
    const closeImageModal = () => {
        setIsImageModalOpen(false)
        setExpandedImage('')
        setExpandedImageAlt('')
    }

    // Função para baixar relatório em base64
    const downloadRelatorio = (base64Data, fileName) => {
        try {
            // Criar um link temporário para download
            const link = document.createElement('a')
            link.href = `data:application/pdf;base64,${base64Data}`
            link.download = fileName || 'relatorio.pdf'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            toast.success('Relatório baixado com sucesso!')
        } catch (error) {
            console.error('Erro ao baixar relatório:', error)
            toast.error('Erro ao baixar relatório')
        }
    }

    // Função para salvar movimentação
    const handleSaveMovimentacao = async () => {
        if (isSubmitting) return

        try {
            setIsSubmitting(true)

            // Validações
            if (!produtoId) {
                toast.error('Produto é obrigatório')
                return
            }

            // Só valida entidade se o produto pode mudar local E não é movimentação interna
            if (selectedProduct?.mudarLocal && !entidadeId && !isInternalMovement) {
                toast.error('Entidade de destino é obrigatória')
                return
            }

            if (!localizacaoId) {
                toast.error('Localização é obrigatória')
                return
            }

            if (!departamentoId) {
                toast.error('Departamento é obrigatório')
                return
            }

            if (!responsavelEntrega || !responsavelEntrega.trim()) {
                toast.error('Responsável pela entrega é obrigatório')
                return
            }

            if (!emailResponsavelEntrega || !emailResponsavelEntrega.trim()) {
                toast.error('Email do responsável é obrigatório')
                return
            }

            // Validar email
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            if (!emailRegex.test(emailResponsavelEntrega)) {
                toast.error('Email do responsável deve ser válido')
                return
            }

            // Preparar dados
            const formData = new FormData()
            formData.append('produto_id', produtoId)
            // Só adiciona entidade_destino_id se o produto pode mudar local E não é movimentação interna
            if (selectedProduct?.mudarLocal && !isInternalMovement) {
                formData.append('entidade_destino_id', entidadeId)
            }
            formData.append('localizacao', localizacaoId)
            formData.append('departamento', departamentoId)
            formData.append('responsavel_entrega', responsavelEntrega)
            formData.append('email_responsavel_entrega', emailResponsavelEntrega)
            formData.append('observacao', observacao)
            formData.append('tipo', 0)
            // Adicionar campo booleano para movimentação interna
            formData.append('interno', isInternalMovement)

            const fotos = []

            // Adicionar imagens
            if (foto1) {
                fotos.push(foto1)
            }
            if (foto2) {
                fotos.push(foto2)
            }
            if (foto3) {
                fotos.push(foto3)
            }
            fotos.forEach((foto, index) => {
                formData.append(`images`, foto)
            });

            const result = await createMovimentacao(formData)
            if (result) {
                toast.success(isEditMode ? 'Movimentação atualizada com sucesso!' : 'Movimentação criada com sucesso!')
                closeModal()
                loadMovimentacoes()
            }
        } catch (error) {
            console.error('Erro ao salvar movimentação:', error)
            toast.error('Erro ao salvar movimentação')
        } finally {
            setIsSubmitting(false)
        }
    }


    // Função para fechar modal de confirmação
    const closeConfirmModal = () => {
        setIsConfirmModalOpen(false)
        setSelectedMovimentacaoForAction(null)
        setConfirmAction(null)
        setConfirmMessage('')
        setConfirmTitle('')
        setConfirmIcon(null)
        setConfirmButtonText('')
        setConfirmButtonColor('')
    }

    // Função para confirmar ação
    const handleConfirmAction = async () => {
        if (!selectedMovimentacaoForAction) return

        try {
            let result
            if (confirmAction === 'cancel') {
                result = await cancelMovimentacoes(selectedMovimentacaoForAction.movimentacao_id)
            } else if (confirmAction === 'return') {
                result = await returnMovimentacoes(selectedMovimentacaoForAction.movimentacao_id)
            }

            if (result) {
                const successMessage = confirmAction === 'cancel'
                    ? 'Movimentação cancelada com sucesso!'
                    : 'Produto retornado ao fornecedor com sucesso!'
                toast.success(successMessage)
                loadMovimentacoes()
                closeConfirmModal()
            }
        } catch (error) {
            console.error(`Erro ao ${confirmAction} movimentação:`, error)
        }
    }

    // Função para carregar localizações do proprietário
    const loadReturnLocalizacoes = async () => {
        setLoadingReturnLocalizacoes(true)
        try {
            const query = new URLSearchParams({
                per_page: 1000,
                sort: 'nome',
                sort_dir: 'asc'
            }).toString()

            const result = await getLocalizacoesProprietario(null, query)
            if (result && Array.isArray(result)) {
                setReturnLocalizacoes([...result].sort((a, b) => String(a.nome || '').localeCompare(String(b.nome || ''), 'pt-BR')))
            } else {
                setReturnLocalizacoes([])
            }
        } catch (error) {
            console.error('Erro ao carregar localizações do proprietário:', error)
            toast.error('Erro ao carregar localizações do proprietário')
            setReturnLocalizacoes([])
        } finally {
            setLoadingReturnLocalizacoes(false)
        }
    }

    // Função para carregar departamentos do retorno
    const loadReturnDepartamentos = async (localizacaoId) => {
        if (!localizacaoId) {
            setReturnDepartamentos([])
            setReturnDepartamentoId('')
            return
        }

        setLoadingReturnDepartamentos(true)
        try {
            const query = new URLSearchParams({
                per_page: 1000,
                sort: 'nome',
                sort_dir: 'asc'
            }).toString()

            const result = await getDepartamentos(localizacaoId, query)
            if (result && Array.isArray(result)) {
                setReturnDepartamentos([...result].sort((a, b) => String(a.nome || '').localeCompare(String(b.nome || ''), 'pt-BR')))
            } else {
                setReturnDepartamentos([])
            }

            // Limpar departamento selecionado
            setReturnDepartamentoId('')
        } catch (error) {
            console.error('Erro ao carregar departamentos:', error)
            toast.error('Erro ao carregar departamentos')
            setReturnDepartamentos([])
        } finally {
            setLoadingReturnDepartamentos(false)
        }
    }


    // Função para fechar modal de retorno
    const closeReturnModal = () => {
        setIsReturnModalOpen(false)
        setReturnMovimentacao(null)
        setReturnLocalizacaoId('')
        setReturnDepartamentoId('')
        setReturnObservacao('')
        setReturnFoto1(null)
        setReturnFoto2(null)
        setReturnFoto3(null)
        setReturnPreviewFoto1('')
        setReturnPreviewFoto2('')
        setReturnPreviewFoto3('')
        setReturnLocalizacoes([])
        setReturnDepartamentos([])
    }

    // Função para enviar retorno para estoque
    const handleReturnToStock = async () => {
        if (isSubmittingReturn) return

        try {
            setIsSubmittingReturn(true)

            // Validações
            if (!returnLocalizacaoId) {
                toast.error('Localização é obrigatória')
                return
            }

            if (!returnDepartamentoId) {
                toast.error('Departamento é obrigatório')
                return
            }

            if (!returnObservacao || !returnObservacao.trim()) {
                toast.error('Observação é obrigatória')
                return
            }


            // Preparar dados
            const formData = new FormData()
            formData.append('localizacao', returnLocalizacaoId)
            formData.append('departamento', returnDepartamentoId)
            formData.append('observacao', returnObservacao)

            // Adicionar imagens
            const fotos = []
            if (returnFoto1) fotos.push(returnFoto1)
            if (returnFoto2) fotos.push(returnFoto2)
            if (returnFoto3) fotos.push(returnFoto3)

            fotos.forEach((foto, index) => {
                formData.append(`images`, foto)
            })

            // Chamar a API de retorno para estoque
            const result = await returnMovimentacoes(formData, returnMovimentacao.movimentacao_id)

            if (result) {
                closeReturnModal()
                loadMovimentacoes()
            }

        } catch (error) {
            console.error('Erro ao retornar produto para estoque:', error)
            toast.error('Erro ao retornar produto para estoque')
        } finally {
            setIsSubmittingReturn(false)
        }
    }

    // Função 

    // Função para criar nova movimentação a partir de uma existente
    const handleCreateFromExisting = (movimentacao) => {
        setProdutoId(movimentacao.produto_id)
        setEntidadeId('')
        setLocalizacaoId('')
        setDepartamentoId('')
        setResponsavelEntrega('')
        setEmailResponsavelEntrega('')
        setObservacao('')
        setFoto1(null)
        setFoto2(null)
        setFoto3(null)
        setPreviewFoto1('')
        setPreviewFoto2('')
        setPreviewFoto3('')
        setLocalizacoes([])
        setDepartamentos([])
        setIsEditMode(false)
        setSelectedMovimentacao(null)
        setIsModalOpen(true)
    }

    // Função para lidar com upload de imagem
    const handleImageUpload = (file, setImage, setPreview) => {
        if (file) {
            setImage(file)
            const reader = new FileReader()
            reader.onload = (e) => {
                setPreview(e.target.result)
            }
            reader.readAsDataURL(file)
        }
    }

    // Função para remover imagem
    const handleRemoveImage = (setImage, setPreview) => {
        setImage(null)
        setPreview('')
    }

    // Função para verificar se é base64 válido
    const isValidBase64 = (str) => {
        try {
            return str && typeof str === 'string' && str.length > 0 && /^[A-Za-z0-9+/]*={0,2}$/.test(str)
        } catch (error) {
            return false
        }
    }

    // Função para criar src de imagem base64
    const createImageSrc = (base64String) => {
        if (isValidBase64(base64String)) {
            return `data:image/webp;base64,${base64String}`
        }
        return ''
    }

    // useEffect para carregar dados iniciais
    useEffect(() => {
        loadMovimentacoes()
        loadSelectData()
        return () => {
            setters.setPage(0)
            setters.setIsLoading(false)
            setters.setDataMovimentacoes([])
        }
    }, [])

    // useEffect para limpar estados quando filtro mudar
    useEffect(() => {
        if (selectedFilterField !== 'movimentacao_usuario') {
            clearUsuarioSelection()
        }
        if (selectedFilterField !== 'cliente') {
            clearClientSelection()
        }
    }, [selectedFilterField])

    // useEffect para monitorar mudanças nas variáveis de query
    useEffect(() => {
        if (states.page >= 0) {
            loadMovimentacoes()
        }
    }, [states.page, recordsPerPage, selectedSortField, sortDirection])

    // useEffect para carregar dados dos selects quando abrir modal
    useEffect(() => {
        if (isModalOpen) {
            loadSelectData()
        }
    }, [isModalOpen])

    // useEffect para recarregar localizações quando produto for selecionado
    useEffect(() => {
        if (selectedProduct) {
            if (isInternalMovement) {
                // Se é movimentação interna, sempre carrega localizações do proprietário
                loadLocalizacoes()
            } else if (selectedProduct.mudarLocal && entidadeId) {
                // Se pode mudar local, carrega localizações da entidade
                loadLocalizacoes(entidadeId)
            } else if (!selectedProduct.mudarLocal) {
                // Se não pode mudar local, carrega localizações do proprietário
                loadLocalizacoes()
            }
        }
    }, [selectedProduct, entidadeId, isInternalMovement])

    // useEffect para fechar dropdown de usuários quando clicar fora
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (isUsuarioDropdownOpen && !event.target.closest('.usuario-search-container')) {
                setIsUsuarioDropdownOpen(false)
            }
            if (isClientDropdownOpen && !event.target.closest('.client-search-container')) {
                setIsClientDropdownOpen(false)
            }
            if (isDestinoClienteDropdownOpen && !event.target.closest('.destino-cliente-search-container')) {
                setIsDestinoClienteDropdownOpen(false)
            }
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [isUsuarioDropdownOpen, isClientDropdownOpen, isDestinoClienteDropdownOpen])

    const truncate = (text, maxLength) => {
        if (!text) return '';
        if (text.length <= maxLength) return text;
        return text.slice(0, maxLength) + '...';
    }

    const idsPaginaMovimentacoes = (states.dataMovimentacoes || []).map(m => String(m.movimentacao_id))
    const paginaTodaSelecionada = idsPaginaMovimentacoes.length > 0 && idsPaginaMovimentacoes.every(id => idsSelecionados.includes(id))

    const toggleSelecaoMovimentacao = (e, id) => {
        e.stopPropagation()
        const idStr = String(id)
        if (idsSelecionados.includes(idStr)) {
            setIdsSelecionados(idsSelecionados.filter(item => item !== idStr))
            return
        }
        setIdsSelecionados([...idsSelecionados, idStr])
    }

    const toggleSelecaoPaginaMovimentacoes = (e) => {
        e.stopPropagation()
        if (paginaTodaSelecionada) {
            setIdsSelecionados(idsSelecionados.filter(id => !idsPaginaMovimentacoes.includes(id)))
            return
        }
        const novos = [...idsSelecionados]
        idsPaginaMovimentacoes.forEach(id => {
            if (!novos.includes(id)) novos.push(id)
        })
        setIdsSelecionados(novos)
    }

    const confirmarExportacaoMovimentacoes = async () => {
        if (idsSelecionados.length === 0) return
        const ok = await exportarListaEmail({ tipo: 'movimentacao', ids: idsSelecionados })
        if (!ok) return
        setIsExportModalOpen(false)
        setIdsSelecionados([])
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-50/30">
            {/* Header Artístico */}
            <div className="relative bg-gradient-to-br from-indigo-50/80 via-white/80 to-blue-50/80 backdrop-blur-sm border-b border-gradient-to-r from-indigo-200/50 to-blue-200/50 sticky top-0 z-10">
                <div className="absolute inset-0 bg-gradient-to-br from-indigo-500/5 to-blue-500/5"></div>
                <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-indigo-400/10 to-blue-400/10 rounded-full -translate-y-16 translate-x-16"></div>
                <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
                        <div>
                            <h1 className="text-4xl font-bold bg-gradient-to-r from-gray-900 via-indigo-800 to-blue-800 bg-clip-text text-transparent">
                                Movimentações
                            </h1>
                            <p className="mt-3 text-lg text-gray-600 font-medium">
                                Gerencie as movimentações de produtos entre entidades
                            </p>
                        </div>
                        <div className="mt-6 sm:mt-0 flex flex-col sm:flex-row gap-3">
                            <button
                                onClick={() => setIsExportModalOpen(true)}
                                disabled={idsSelecionados.length === 0}
                                className="group relative inline-flex items-center px-8 py-4 border border-transparent rounded-2xl shadow-xl text-sm font-semibold text-white bg-gradient-to-r from-emerald-600 via-teal-700 to-teal-700 hover:from-emerald-700 hover:via-teal-800 hover:to-teal-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500 transition-all duration-300 transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
                            >
                                <div className="relative z-10 flex items-center">
                                    <EnvelopeIcon className="w-6 h-6 mr-3 group-hover:scale-110 transition-transform duration-200" />
                                    <span className="text-base font-bold">Exportar e enviar por e-mail</span>
                                </div>
                            </button>
                            <button
                                onClick={() => openModal()}
                                className="group relative inline-flex items-center px-8 py-4 border border-transparent rounded-2xl shadow-xl text-sm font-semibold text-white bg-gradient-to-r from-indigo-600 via-blue-700 to-blue-700 hover:from-indigo-700 hover:via-blue-800 hover:to-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-all duration-300 transform hover:scale-105"
                            >
                                <div className="relative z-10 flex items-center">
                                    <PlusIcon className="w-6 h-6 mr-3 group-hover:scale-110 transition-transform duration-200" />
                                    <span className="text-base font-bold">Nova Movimentação</span>
                                </div>
                                <div className="absolute inset-0 bg-gradient-to-r from-indigo-500/10 to-blue-500/10 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Conteúdo Principal */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">

                {/* Formulário de Busca - Design Artístico */}
                <div className="relative bg-gradient-to-br from-indigo-50/80 via-white/80 to-blue-50/80 backdrop-blur-sm rounded-3xl shadow-lg border border-indigo-100/50 mb-8 overflow-hidden">
                    <div className="absolute inset-0 bg-gradient-to-br from-indigo-500/5 to-blue-500/5"></div>
                    <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-indigo-400/10 to-blue-400/10 rounded-full -translate-y-16 translate-x-16"></div>
                    <div className="relative p-6">
                        <div className="flex items-center mb-4">
                            <div className="p-3 rounded-2xl bg-gradient-to-r from-indigo-500 via-blue-600 to-blue-600 shadow-lg mr-4">
                                <MagnifyingGlassIcon className="w-6 h-6 text-white" />
                            </div>
                            <h2 className="text-2xl font-bold bg-gradient-to-r from-gray-900 via-indigo-800 to-blue-800 bg-clip-text text-transparent">
                                Pesquisa Avançada
                            </h2>
                        </div>

                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 mb-6">
                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-2">Termo de Busca</label>
                                {selectedFilterField === 'movimentacao_usuario' ? (
                                    <div className="relative usuario-search-container">
                                        <input
                                            type="text"
                                            value={usuarioSearchTerm}
                                            onChange={(e) => {
                                                const value = e.target.value
                                                setUsuarioSearchTerm(value)
                                                if (value.length >= 2) {
                                                    searchUsuarios(value)
                                                } else {
                                                    setUsuarioSearchResults([])
                                                    setIsUsuarioDropdownOpen(false)
                                                }
                                            }}
                                            onFocus={() => {
                                                if (usuarioSearchResults.length > 0) {
                                                    setIsUsuarioDropdownOpen(true)
                                                }
                                            }}
                                            placeholder="Digite o nome do usuário (mín. 2 caracteres)"
                                            className="w-full px-4 py-3 border border-indigo-200 rounded-2xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-300 bg-white/80 backdrop-blur-sm"
                                        />

                                        {/* Loading indicator */}
                                        {loadingUsuarioSearch && (
                                            <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                                                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-indigo-600"></div>
                                            </div>
                                        )}

                                        {/* Dropdown de resultados */}
                                        {isUsuarioDropdownOpen && usuarioSearchResults.length > 0 && (
                                            <div className="absolute z-50 w-full mt-1 bg-white border border-indigo-300 rounded-xl shadow-lg max-h-60 overflow-y-auto">
                                                {usuarioSearchResults.map((usuario) => (
                                                    <div
                                                        key={usuario.id}
                                                        onClick={() => selectUsuario(usuario)}
                                                        className="px-4 py-3 hover:bg-indigo-50 cursor-pointer border-b border-indigo-100 last:border-b-0 transition-colors duration-200"
                                                    >
                                                        <div className="flex items-center justify-between">
                                                            <div>
                                                                <p className="font-medium text-gray-900">{usuario.nome}</p>
                                                                {usuario.email && (
                                                                    <p className="text-sm text-gray-600">{usuario.email}</p>
                                                                )}
                                                            </div>
                                                            <div className="text-xs text-gray-500">
                                                                Usuário
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                ) : selectedFilterField === 'cliente' ? (
                                    <div className="relative client-search-container">
                                        <input
                                            type="text"
                                            value={clientSearchTerm}
                                            onChange={(e) => {
                                                const value = e.target.value
                                                setClientSearchTerm(value)
                                                if (value.length >= 2) {
                                                    searchClients(value)
                                                } else {
                                                    setClientSearchResults([])
                                                    setIsClientDropdownOpen(false)
                                                }
                                            }}
                                            onFocus={() => {
                                                if (clientSearchResults.length > 0) {
                                                    setIsClientDropdownOpen(true)
                                                }
                                            }}
                                            placeholder="Digite o nome do cliente (mín. 2 caracteres)"
                                            className="w-full px-4 py-3 border border-indigo-200 rounded-2xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-300 bg-white/80 backdrop-blur-sm"
                                        />

                                        {loadingClientSearch && (
                                            <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                                                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-indigo-600"></div>
                                            </div>
                                        )}

                                        {isClientDropdownOpen && clientSearchResults.length > 0 && (
                                            <div className="absolute z-50 w-full mt-1 bg-white border border-indigo-300 rounded-xl shadow-lg max-h-60 overflow-y-auto">
                                                {clientSearchResults.map((client) => (
                                                    <div
                                                        key={client.id}
                                                        onClick={() => selectClient(client)}
                                                        className="px-4 py-3 hover:bg-indigo-50 cursor-pointer border-b border-indigo-100 last:border-b-0 transition-colors duration-200"
                                                    >
                                                        <div className="flex items-center justify-between">
                                                            <div>
                                                                <p className="font-medium text-gray-900">{client.nome}</p>
                                                                {client.email && (
                                                                    <p className="text-sm text-gray-600">{client.email}</p>
                                                                )}
                                                            </div>
                                                            <div className="text-xs text-gray-500">
                                                                {client.tipo === 1 ? 'Pessoa Jurídica' : 'Pessoa Física'}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <input
                                        type={selectedFilterField === 'produto_codigo_net' ? 'number' : 'text'}
                                        value={searchTerm}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                handleSearch()
                                            }
                                        }}
                                        onChange={(e) => {
                                            if (selectedFilterField === 'produto_codigo_net') {
                                                // Aceitar apenas números inteiros maiores que 0
                                                const value = e.target.value
                                                if (value === '' || (Number.isInteger(Number(value)) && Number(value) > 0)) {
                                                    setSearchTerm(value)
                                                }
                                            } else {
                                                setSearchTerm(e.target.value)
                                            }
                                        }}
                                        placeholder={selectedFilterField === 'produto_codigo_net' ? 'Digite o código NET (ex: 123)' : 'Digite para buscar...'}
                                        min={selectedFilterField === 'produto_codigo_net' ? '1' : undefined}
                                        className="w-full px-4 py-3 border border-indigo-200 rounded-2xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-300 bg-white/80 backdrop-blur-sm"
                                    />
                                )}
                            </div>

                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-2">Campo de Filtro</label>
                                <select
                                    value={selectedFilterField}
                                    onChange={(e) => setSelectedFilterField(e.target.value)}
                                    className="w-full px-4 py-3 border border-indigo-200 rounded-2xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-300 bg-white/80 backdrop-blur-sm"
                                >
                                    {filterOptions.map((option) => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-2">Campo de Ordenação</label>
                                <select
                                    value={selectedSortField}
                                    onChange={(e) => setSelectedSortField(e.target.value)}
                                    className="w-full px-4 py-3 border border-indigo-200 rounded-2xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-300 bg-white/80 backdrop-blur-sm"
                                >
                                    {sortOptions.map((option) => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-2">Direção da Ordenação</label>
                                <div className="relative">
                                    <select
                                        value={sortDirection}
                                        onChange={(e) => setSortDirection(e.target.value)}
                                        className="w-full px-4 py-3 pl-10 border border-indigo-200 rounded-2xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-300 bg-white/80 backdrop-blur-sm appearance-none"
                                    >
                                        <option value="asc">Crescente (A-Z)</option>
                                        <option value="desc">Decrescente (Z-A)</option>
                                    </select>
                                    <div className="absolute left-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                        {sortDirection === 'asc' ? (
                                            <BarsArrowUpIcon className="w-5 h-5 text-indigo-600" />
                                        ) : (
                                            <BarsArrowDownIcon className="w-5 h-5 text-indigo-600" />
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-2">Registros por Página</label>
                                <select
                                    value={recordsPerPage}
                                    onChange={(e) => setRecordsPerPage(Number(e.target.value))}
                                    className="w-full px-4 py-3 border border-indigo-200 rounded-2xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-300 bg-white/80 backdrop-blur-sm"
                                >
                                    <option value={5}>5 registros</option>
                                    <option value={10}>10 registros</option>
                                    <option value={20}>20 registros</option>
                                    <option value={50}>50 registros</option>
                                </select>
                            </div>
                        </div>

                        <div className="flex flex-col sm:flex-row gap-4">
                            <button
                                onClick={handleSearch}
                                className="flex-1 group relative inline-flex items-center justify-center px-6 py-3 border border-transparent rounded-2xl shadow-lg text-sm font-semibold text-white bg-gradient-to-r from-indigo-600 via-blue-700 to-blue-700 hover:from-indigo-700 hover:via-blue-800 hover:to-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-all duration-300 transform hover:scale-105"
                            >
                                <div className="relative z-10 flex items-center">
                                    <MagnifyingGlassIcon className="w-5 h-5 mr-2 group-hover:scale-110 transition-transform duration-200" />
                                    <span>Buscar</span>
                                </div>
                                <div className="absolute inset-0 bg-gradient-to-r from-indigo-500/10 to-blue-500/10 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                            </button>

                            <button
                                onClick={handleClear}
                                className="flex-1 group relative inline-flex items-center justify-center px-6 py-3 border border-indigo-300 rounded-2xl shadow-lg text-sm font-semibold text-indigo-700 bg-gradient-to-r from-indigo-50 to-indigo-50 hover:from-indigo-100 hover:to-indigo-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-all duration-300 transform hover:scale-105"
                            >
                                <div className="relative z-10 flex items-center">
                                    <XMarkIcon className="w-5 h-5 mr-2 group-hover:scale-110 transition-transform duration-200" />
                                    <span>Limpar</span>
                                </div>
                                <div className="absolute inset-0 bg-gradient-to-r from-indigo-500/10 to-blue-500/10 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                            </button>

                            <button
                                onClick={() => setIsExportModalOpen(true)}
                                disabled={idsSelecionados.length === 0}
                                className="flex-1 group relative inline-flex items-center justify-center px-6 py-3 border border-transparent rounded-2xl shadow-lg text-sm font-semibold text-white bg-gradient-to-r from-emerald-600 via-teal-700 to-teal-700 hover:from-emerald-700 hover:via-teal-800 hover:to-teal-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500 transition-all duration-300 transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
                            >
                                <div className="relative z-10 flex items-center">
                                    <EnvelopeIcon className="w-5 h-5 mr-2 group-hover:scale-110 transition-transform duration-200" />
                                    <span>Exportar e enviar por e-mail</span>
                                </div>
                            </button>
                        </div>

                        {/* Exibir usuário selecionado quando filtro de usuário estiver ativo */}
                        {selectedFilterField === 'movimentacao_usuario' && selectedUsuario && (
                            <div className="mt-4 p-4 bg-indigo-50 border border-indigo-200 rounded-xl">
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center space-x-3">
                                        <div className="w-3 h-3 bg-indigo-500 rounded-full"></div>
                                        <div>
                                            <p className="text-sm font-medium text-indigo-800">Usuário selecionado:</p>
                                            <p className="text-lg font-semibold text-indigo-900">{selectedUsuario.nome}</p>
                                            {selectedUsuario.email && (
                                                <p className="text-xs text-indigo-600">{selectedUsuario.email}</p>
                                            )}
                                        </div>
                                    </div>
                                    <button
                                        onClick={clearUsuarioSelection}
                                        className="px-3 py-1 text-sm bg-indigo-100 text-indigo-700 rounded-lg hover:bg-indigo-200 transition-colors duration-200"
                                    >
                                        <XMarkIcon className="w-4 h-4 inline mr-1" />
                                        Remover
                                    </button>
                                </div>
                            </div>
                        )}

                        {selectedFilterField === 'cliente' && selectedClient && (
                            <div className="mt-4 p-4 bg-indigo-50 border border-indigo-200 rounded-xl">
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center space-x-3">
                                        <div className="w-3 h-3 bg-indigo-500 rounded-full"></div>
                                        <div>
                                            <p className="text-sm font-medium text-indigo-800">Cliente selecionado:</p>
                                            <p className="text-lg font-semibold text-indigo-900">{selectedClient.nome}</p>
                                            {selectedClient.email && (
                                                <p className="text-xs text-indigo-600">{selectedClient.email}</p>
                                            )}
                                        </div>
                                    </div>
                                    <button
                                        onClick={clearClientSelection}
                                        className="px-3 py-1 text-sm bg-indigo-100 text-indigo-700 rounded-lg hover:bg-indigo-200 transition-colors duration-200"
                                    >
                                        <XMarkIcon className="w-4 h-4 inline mr-1" />
                                        Remover
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {/* Lista de Movimentações */}
                <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
                    <div className="overflow-x-auto">
                        <div className="px-6 py-4 border-b border-gray-200">
                            <h2 className="text-lg font-semibold text-gray-900">Lista de Movimentações</h2>
                        </div>

                        {states.loading ? (
                            <div className="flex items-center justify-center py-12">
                                <div className="text-center">
                                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto"></div>
                                    <p className="mt-4 text-gray-600">Carregando movimentações...</p>
                                </div>
                            </div>
                        ) : states.dataMovimentacoes && states.dataMovimentacoes.length > 0 ? (
                            <>
                                {/* Header da Lista - Desktop */}
                                <div className="hidden lg:block px-3 py-2 bg-gray-50 border-b border-gray-200">
                                    <div className="grid grid-cols-12 gap-1 items-center text-xs font-medium text-gray-500 uppercase tracking-wide min-w-[1200px]">
                                        <div className="col-span-1 flex items-center justify-center space-x-1">
                                            <div onClick={(e) => e.stopPropagation()}>
                                                <input
                                                    type="checkbox"
                                                    checked={paginaTodaSelecionada}
                                                    onClick={(e) => e.stopPropagation()}
                                                    onChange={toggleSelecaoPaginaMovimentacoes}
                                                    title="Selecionar página"
                                                    className="w-3 h-3 text-indigo-600 border-gray-300 rounded cursor-pointer"
                                                />
                                            </div>
                                            <TruckIcon className="w-3 h-3 mr-1" />
                                            Ações
                                        </div>
                                        <div className="col-span-1 flex items-center justify-center">
                                            <UserIcon className="w-3 h-3 mr-1" />
                                            Usuário
                                        </div>
                                        <div className="col-span-1 flex items-center justify-center">
                                            <InformationCircleIcon className="w-3 h-3 mr-1" />
                                            Código NET
                                        </div>
                                        <div className="col-span-2 flex items-center justify-center">
                                            <TruckIcon className="w-3 h-3 mr-1" />
                                            Produto
                                        </div>
                                        <div className="col-span-2 flex items-center justify-center">
                                            <UserIcon className="w-3 h-3 mr-1" />
                                            Cliente
                                        </div>
                                        <div className="col-span-1 flex items-center justify-center">
                                            <UserIcon className="w-3 h-3 mr-1" />
                                            Responsável
                                        </div>
                                        <div className="col-span-1 flex items-center justify-center">
                                            <MapPinIcon className="w-3 h-3 mr-1" />
                                            Local
                                        </div>
                                        <div className="col-span-1 flex items-center justify-center">
                                            <BuildingOfficeIcon className="w-3 h-3 mr-1" />
                                            Depto
                                        </div>
                                        <div className="col-span-1 flex items-center justify-center">
                                            <CalendarIcon className="w-3 h-3 mr-1" />
                                            Data
                                        </div>
                                        <div className="col-span-1 flex items-center justify-center">
                                            <ChartBarIcon className="w-3 h-3 mr-1" />
                                            Status
                                        </div>
                                    </div>
                                </div>

                                {/* Lista de Movimentações */}
                                <div className="divide-y divide-gray-200">
                                    {states.dataMovimentacoes.map((movimentacao) => {
                                        const tipo = tiposMovimentacao.find(t => t.value === movimentacao.movimentacao_tipo)
                                        const IconComponent = tipo?.icon || TruckIcon

                                        return (
                                            <div
                                                key={movimentacao.movimentacao_id}
                                                className="px-3 py-2 hover:bg-gray-50 transition-colors duration-200"
                                            >
                                                {/* Desktop Layout */}
                                                <div className="hidden lg:block">
                                                    <div className="grid grid-cols-12 gap-1 items-center min-w-[1200px]">
                                                        {/* Ações */}
                                                        <div className="col-span-1 flex items-center justify-center space-x-1">
                                                            <div onClick={(e) => e.stopPropagation()}>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={idsSelecionados.includes(String(movimentacao.movimentacao_id))}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                    onChange={(e) => toggleSelecaoMovimentacao(e, movimentacao.movimentacao_id)}
                                                                    className="w-3 h-3 text-indigo-600 border-gray-300 rounded cursor-pointer"
                                                                />
                                                            </div>
                                                            <button
                                                                onClick={() => openViewModal(movimentacao)}
                                                                className="p-1 bg-indigo-100 text-indigo-700 rounded hover:bg-indigo-200 transition-colors duration-200"
                                                                title="Visualizar"
                                                            >
                                                                <EyeIcon className="w-3 h-3" />
                                                            </button>
                                                            {localStorage.getItem('usuario') === jsonConfig.userMaster && (
                                                                <button
                                                                    onClick={() => openEditModal(movimentacao)}
                                                                    className="p-1 bg-blue-100 text-blue-700 rounded hover:bg-blue-200 transition-colors duration-200"
                                                                    title="Editar"
                                                                >
                                                                    <PencilSquareIcon className="w-3 h-3" />
                                                                </button>
                                                            )}
                                                        </div>

                                                        {/* Usuário Responsável */}
                                                        <div className="col-span-1 text-center">
                                                            <div className="text-xs font-medium text-gray-900 truncate">
                                                                {movimentacao.movimentacao_usuario || 'N/A'}
                                                            </div>
                                                        </div>

                                                        {/* Código NET - DESTAQUE */}
                                                        <div className="col-span-1 flex justify-center">
                                                            <div className="inline-flex items-center px-1 py-0.5 rounded text-xs font-bold bg-gradient-to-r from-blue-600 to-indigo-600 text-white">
                                                                #{movimentacao.produto_codigo_net}
                                                            </div>
                                                        </div>

                                                        {/* Produto */}
                                                        <div className="col-span-2 text-center">
                                                            <div className="text-xs font-medium text-gray-900 truncate">
                                                                {movimentacao.produto_modelo}
                                                            </div>
                                                            <div className="text-xs text-gray-500 truncate">
                                                                {movimentacao.produto_serial}
                                                            </div>
                                                        </div>

                                                        {/* Cliente */}
                                                        <div className="col-span-2 text-center">
                                                            <div className="text-xs font-medium text-gray-900 truncate">
                                                                {movimentacao.entidade_destino_nome || 'N/A'}
                                                            </div>
                                                        </div>

                                                        {/* Responsável */}
                                                        <div className="col-span-1 text-center">
                                                            <div className="text-xs font-medium text-gray-900 truncate">
                                                                {movimentacao.movimentacao_responsavel_entrega}
                                                            </div>
                                                            <div className="text-xs text-gray-500 truncate">
                                                                {movimentacao.movimentacao_email_responsavel_entrega}
                                                            </div>
                                                        </div>

                                                        {/* Local */}
                                                        <div className="col-span-1 text-center">
                                                            <div className="text-xs font-medium text-gray-900 truncate">
                                                                {movimentacao.local_nome || 'N/A'}
                                                            </div>
                                                        </div>

                                                        {/* Departamento */}
                                                        <div className="col-span-1 text-center">
                                                            <div className="text-xs font-medium text-gray-900 truncate">
                                                                {movimentacao.departamento_nome || 'N/A'}
                                                            </div>
                                                        </div>

                                                        {/* Data */}
                                                        <div className="col-span-1 text-center">
                                                            <div className="text-xs text-gray-900">
                                                                {new Date(movimentacao.movimentacao_data_movimentacao).toLocaleDateString('pt-BR')}
                                                            </div>
                                                            <div className="text-xs text-gray-500">
                                                                {new Date(movimentacao.movimentacao_data_movimentacao).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}
                                                            </div>
                                                        </div>

                                                        {/* Status */}
                                                        <div className="col-span-1 flex justify-center">
                                                            <span className={`inline-flex items-center px-1 py-0.5 rounded text-xs font-medium ${tipo?.color || 'bg-gray-500'}`}>
                                                                <IconComponent className="w-2 h-2 mr-0.5" />
                                                                {tipo?.label || 'Desconhecido'}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Mobile Layout */}
                                                <div className="lg:hidden">
                                                    <div className="space-y-3">
                                                        {/* Header Mobile */}
                                                        <div className="flex items-center justify-between">
                                                            <div className="flex items-center space-x-3">
                                                                <div onClick={(e) => e.stopPropagation()}>
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={idsSelecionados.includes(String(movimentacao.movimentacao_id))}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                        onChange={(e) => toggleSelecaoMovimentacao(e, movimentacao.movimentacao_id)}
                                                                        className="w-4 h-4 text-indigo-600 border-gray-300 rounded cursor-pointer"
                                                                    />
                                                                </div>
                                                                <div className="inline-flex items-center px-3 py-1 rounded-full text-sm font-bold bg-gradient-to-r from-blue-600 to-indigo-600 text-white">
                                                                    #{movimentacao.produto_codigo_net}
                                                                </div>
                                                                <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${tipo?.color || 'bg-gray-500'}`}>
                                                                    <IconComponent className="w-3 h-3 mr-1" />
                                                                    {tipo?.label || 'Desconhecido'}
                                                                </span>
                                                            </div>
                                                            <div className="flex space-x-2">
                                                                <button
                                                                    onClick={() => openViewModal(movimentacao)}
                                                                    className="p-2 bg-indigo-100 text-indigo-700 rounded-lg hover:bg-indigo-200 transition-colors duration-200"
                                                                    title="Visualizar"
                                                                >
                                                                    <EyeIcon className="w-4 h-4" />
                                                                </button>
                                                                {localStorage.getItem('usuario') === jsonConfig.userMaster && (
                                                                    <button
                                                                        onClick={() => openEditModal(movimentacao)}
                                                                        className="p-2 bg-blue-100 text-blue-700 rounded-lg hover:bg-blue-200 transition-colors duration-200"
                                                                        title="Editar"
                                                                    >
                                                                        <PencilSquareIcon className="w-4 h-4" />
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </div>

                                                        {/* Informações Mobile */}
                                                        <div className="space-y-2">
                                                            <div className="flex items-center justify-between">
                                                                <span className="text-sm font-medium text-gray-500">Produto:</span>
                                                                <span className="text-sm text-gray-900">{movimentacao.produto_modelo}</span>
                                                            </div>
                                                            <div className="flex items-center justify-between">
                                                                <span className="text-sm font-medium text-gray-500">Cliente:</span>
                                                                <span className="text-sm text-gray-900">{movimentacao.entidade_destino_nome || 'N/A'}</span>
                                                            </div>
                                                            <div className="flex items-center justify-between">
                                                                <span className="text-sm font-medium text-gray-500">Serial:</span>
                                                                <span className="text-sm text-gray-900">{truncate(movimentacao.produto_serial, 15)}</span>
                                                            </div>
                                                            <div className="flex items-center justify-between">
                                                                <span className="text-sm font-medium text-gray-500">Responsável:</span>
                                                                <span className="text-sm text-gray-900">{movimentacao.movimentacao_responsavel_entrega}</span>
                                                            </div>
                                                            <div className="flex items-center justify-between">
                                                                <span className="text-sm font-medium text-gray-500">Local:</span>
                                                                <span className="text-sm text-gray-900">{movimentacao.local_nome || 'N/A'}</span>
                                                            </div>
                                                            <div className="flex items-center justify-between">
                                                                <span className="text-sm font-medium text-gray-500">Departamento:</span>
                                                                <span className="text-sm text-gray-900">{movimentacao.departamento_nome || 'N/A'}</span>
                                                            </div>
                                                            <div className="flex items-center justify-between">
                                                                <span className="text-sm font-medium text-gray-500">Data:</span>
                                                                <span className="text-sm text-gray-900">
                                                                    {new Date(movimentacao.movimentacao_data_movimentacao).toLocaleDateString('pt-BR')} {new Date(movimentacao.movimentacao_data_movimentacao).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </>
                        ) : (
                            <div className="px-6 py-8 text-center text-gray-500">
                                <ArchiveBoxIcon className="w-16 h-16 text-gray-400 mx-auto mb-4" />
                                <h3 className="text-lg font-medium text-gray-900 mb-2">Nenhuma movimentação encontrada</h3>
                                <p className="text-gray-500 mb-6">Comece criando sua primeira movimentação para ver os dados aqui.</p>
                                <button
                                    onClick={() => openModal()}
                                    className="inline-flex items-center px-4 py-2 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                >
                                    <PlusIcon className="w-4 h-4 mr-2" />
                                    Criar Movimentação
                                </button>
                            </div>
                        )}
                    </div>
                </div>

                {/* Paginação */}
                {states.dataMovimentacoes && states.dataMovimentacoes.length > 0 && (
                    <div className="flex items-center justify-between bg-white rounded-2xl shadow-lg border border-gray-200 p-4">
                        <div className="text-sm text-gray-700">
                            Mostrando {(states.page * recordsPerPage) + 1} a {Math.min((states.page + 1) * recordsPerPage, states.dataMovimentacoes?.length || 0)} de {states.dataMovimentacoes?.length || 0} movimentações
                        </div>
                        <div className="flex space-x-2">
                            <button
                                onClick={handlePrevious}
                                disabled={states.page === 0}
                                className="px-3 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
                            >
                                <ChevronLeftIcon className="w-4 h-4" />
                            </button>
                            <span className="px-3 py-2 text-sm font-medium text-gray-700">
                                Página {states.page + 1}
                            </span>
                            <button
                                onClick={handleNext}
                                disabled={(states.dataMovimentacoes?.length || 0) < recordsPerPage}
                                className="px-3 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
                            >
                                <ChevronRightIcon className="w-4 h-4" />
                            </button>
                        </div>
                    </div>
                )}
            </div>

            {/* Modal de Adicionar/Editar Movimentação */}
            {isModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center p-4 z-50">
                    <div className="relative flex max-h-[90vh] w-full max-w-2xl flex-col overflow-hidden rounded-3xl bg-white shadow-2xl">
                        {/* Header do Modal */}
                        <div className="relative shrink-0 bg-gradient-to-r from-indigo-600 via-blue-700 to-blue-700 rounded-t-3xl p-6">
                            <div className="absolute inset-0 bg-gradient-to-r from-indigo-500/10 to-blue-500/10 rounded-t-3xl"></div>
                            <div className="relative flex items-center justify-between">
                                <div className="flex items-center">
                                    <div className="p-3 rounded-2xl bg-white/20 backdrop-blur-sm mr-4">
                                        <TruckIcon className="w-8 h-8 text-white" />
                                    </div>
                                    <div>
                                        <h2 className="text-2xl font-bold text-white">
                                            {isEditMode ? 'Editar Movimentação' : 'Nova Movimentação'}
                                        </h2>
                                        <p className="text-indigo-100 mt-1">
                                            {isEditMode ? 'Atualize os dados da movimentação' : 'Preencha os dados para criar uma nova movimentação'}
                                        </p>
                                        {selectedProduct && (
                                            <div className="mt-2 flex items-center">
                                                <span className="text-indigo-200 text-sm font-medium">Código NET:</span>
                                                <span className="ml-2 inline-flex items-center px-2 py-1 rounded-full text-xs font-bold bg-white/20 text-white">
                                                    #{selectedProduct.codigo_net}
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <button
                                    onClick={closeModal}
                                    className="p-2 rounded-full bg-white/20 backdrop-blur-sm text-white hover:bg-white/30 transition-colors duration-200"
                                >
                                    <XMarkIcon className="w-6 h-6" />
                                </button>
                            </div>
                        </div>

                        {/* Conteúdo do Modal */}
                        <div className="min-h-0 flex-1 overflow-y-auto">
                            <div className="p-6 space-y-6">
                                {/* Produto */}
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                                        Produto *
                                    </label>

                                    {/* Campo de Busca - só aparece quando não há produto selecionado */}
                                    {!selectedProduct && (
                                        <div className="relative">
                                            <input
                                                type="text"
                                                value={productSearchTerm}
                                                onChange={(e) => setProductSearchTerm(e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        handleProductSearch()
                                                    }
                                                }}
                                                onBlur={() => {
                                                    if (productSearchTerm.trim()) {
                                                        handleProductSearch()
                                                    }
                                                }}
                                                placeholder="Digite o código NET do produto..."
                                                className="w-full px-4 py-3 pr-12 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-300"
                                            />
                                            <button
                                                type="button"
                                                onClick={handleProductSearch}
                                                className="absolute right-3 top-1/2 transform -translate-y-1/2 p-1 text-gray-400 hover:text-indigo-600 transition-colors duration-200"
                                            >
                                                <MagnifyingGlassIcon className="w-5 h-5" />
                                            </button>
                                        </div>
                                    )}

                                    {/* Produto Selecionado - aparece quando há produto selecionado */}
                                    {selectedProduct && (
                                        <div className="p-4 bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-xl">
                                            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-3 sm:space-y-0">
                                                <div className="flex items-center">
                                                    <div className="p-2 rounded-lg bg-blue-100 text-blue-700 mr-3">
                                                        <InformationCircleIcon className="w-5 h-5" />
                                                    </div>
                                                    <div className="min-w-0 flex-1">
                                                        <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-3 space-y-1 sm:space-y-0">
                                                            <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-bold bg-gradient-to-r from-blue-600 to-indigo-600 text-white w-fit">
                                                                #{selectedProduct.codigo_net}
                                                            </span>
                                                            <span className="text-lg font-semibold text-gray-900 truncate">
                                                                {selectedProduct.modelo}
                                                            </span>
                                                        </div>
                                                        <div className="mt-1 text-sm text-gray-600">
                                                            Serial: {selectedProduct.serial}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="flex items-center justify-between sm:justify-end space-x-2">
                                                    {/* Botão de Movimentação Interna - só aparece quando produto está em estoque */}
                                                    {selectedProduct.mudarLocal && (
                                                        <button
                                                            type="button"
                                                            onClick={() => {
                                                                setIsInternalMovement(!isInternalMovement)
                                                                // Limpar entidade quando ativar movimentação interna
                                                                if (!isInternalMovement) {
                                                                    setEntidadeId('')
                                                                    setLocalizacaoId('')
                                                                    setDepartamentoId('')
                                                                    setLocalizacoes([])
                                                                    setDepartamentos([])
                                                                    setDestinoClienteTerm('')
                                                                    setDestinoClienteResults([])
                                                                    setDestinoClienteSelected(null)
                                                                    setIsDestinoClienteDropdownOpen(false)
                                                                    setDestinoClientePage(0)
                                                                    setDestinoClienteHasMore(true)
                                                                    // Carregar localizações do proprietário
                                                                    loadLocalizacoes()
                                                                }
                                                            }}
                                                            className={`px-3 py-2 rounded-lg text-xs sm:text-sm font-medium transition-all duration-200 whitespace-nowrap ${isInternalMovement
                                                                ? 'bg-green-100 text-green-700 border border-green-300'
                                                                : 'bg-gray-100 text-gray-700 border border-gray-300 hover:bg-gray-200'
                                                                }`}
                                                        >
                                                            {isInternalMovement ? '✓ Interna' : 'Movimentação Interna'}
                                                        </button>
                                                    )}
                                                    <button
                                                        type="button"
                                                        onClick={() => {
                                                            setSelectedProduct(null)
                                                            setProdutoId('')
                                                            setProductSearchTerm('')
                                                            setIsInternalMovement(false)
                                                        }}
                                                        className="p-2 text-gray-400 hover:text-red-500 transition-colors duration-200 flex-shrink-0"
                                                    >
                                                        <XMarkIcon className="w-5 h-5" />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* Entidade - só aparece quando produto pode mudar local E não é movimentação interna */}
                                {selectedProduct && selectedProduct.mudarLocal && !isInternalMovement && (
                                    <div>
                                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                                            Cliente de Destino *
                                        </label>
                                        <div className="relative destino-cliente-search-container">
                                            <input
                                                type="text"
                                                value={destinoClienteTerm}
                                                onChange={(e) => {
                                                    const value = e.target.value
                                                    setDestinoClienteTerm(value)
                                                    if (destinoClienteSelected) {
                                                        setDestinoClienteSelected(null)
                                                        setEntidadeId('')
                                                        setLocalizacaoId('')
                                                        setDepartamentoId('')
                                                        setLocalizacoes([])
                                                        setDepartamentos([])
                                                    }
                                                    loadDestinoClientes(value, 0, false)
                                                }}
                                                onFocus={() => {
                                                    if (destinoClienteResults.length > 0) {
                                                        setIsDestinoClienteDropdownOpen(true)
                                                    }
                                                }}
                                                placeholder="Pesquisar cliente por nome"
                                                className="w-full px-4 py-3 pr-20 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-300"
                                            />
                                            <div className="absolute right-2 top-1/2 transform -translate-y-1/2 flex items-center space-x-1">
                                                {loadingDestinoCliente && (
                                                    <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-indigo-600"></div>
                                                )}
                                                {destinoClienteSelected && (
                                                    <button
                                                        type="button"
                                                        onClick={clearDestinoCliente}
                                                        className="p-1 text-gray-400 hover:text-red-500 transition-colors duration-200"
                                                    >
                                                        <XMarkIcon className="w-5 h-5" />
                                                    </button>
                                                )}
                                                <button
                                                    type="button"
                                                    onClick={() => {
                                                        if (isDestinoClienteDropdownOpen) {
                                                            setIsDestinoClienteDropdownOpen(false)
                                                        } else {
                                                            setIsDestinoClienteDropdownOpen(true)
                                                            loadDestinoClientes(destinoClienteTerm, 0, false)
                                                        }
                                                    }}
                                                    className="p-1 text-gray-400 hover:text-indigo-600 transition-colors duration-200"
                                                >
                                                    {isDestinoClienteDropdownOpen ? (
                                                        <ChevronUpIcon className="w-5 h-5" />
                                                    ) : (
                                                        <ChevronDownIcon className="w-5 h-5" />
                                                    )}
                                                </button>
                                            </div>
                                            {isDestinoClienteDropdownOpen && (
                                                <div className="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-xl shadow-lg max-h-60 overflow-y-auto">
                                                    {destinoClienteResults.map((client) => (
                                                        <div
                                                            key={client.id}
                                                            onClick={() => selectDestinoCliente(client)}
                                                            className="px-4 py-3 hover:bg-indigo-50 cursor-pointer border-b border-gray-100 last:border-b-0 transition-colors duration-200"
                                                        >
                                                            <div className="flex items-center justify-between">
                                                                <div>
                                                                    <p className="font-medium text-gray-900">{client.nome}</p>
                                                                    {client.email && (
                                                                        <p className="text-sm text-gray-600">{client.email}</p>
                                                                    )}
                                                                </div>
                                                                <div className="text-xs text-gray-500">
                                                                    {client.tipo === 1 ? 'Pessoa Jurídica' : 'Pessoa Física'}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                    {!loadingDestinoCliente && destinoClienteResults.length === 0 && (
                                                        <div className="px-4 py-3 text-sm text-gray-500">
                                                            Nenhum cliente encontrado
                                                        </div>
                                                    )}
                                                    {destinoClienteHasMore && destinoClienteResults.length > 0 && (
                                                        <button
                                                            type="button"
                                                            onClick={() => loadDestinoClientes(destinoClienteTerm, destinoClientePage + 1, true)}
                                                            disabled={loadingDestinoCliente}
                                                            className="w-full px-4 py-3 text-sm font-medium text-indigo-600 hover:bg-indigo-50 disabled:opacity-50 transition-colors duration-200"
                                                        >
                                                            {loadingDestinoCliente ? 'Carregando...' : 'Ver mais'}
                                                        </button>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}

                                {/* Localização */}
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                                        Localização *
                                    </label>
                                    <select
                                        value={localizacaoId}
                                        onChange={(e) => {
                                            setLocalizacaoId(e.target.value)
                                            loadDepartamentos(e.target.value)
                                        }}
                                        disabled={loadingLocalizacoes || (selectedProduct?.mudarLocal && !entidadeId && !isInternalMovement)}
                                        className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-300 disabled:bg-gray-100 disabled:cursor-not-allowed"
                                    >
                                        <option value="">
                                            {loadingLocalizacoes ? 'Carregando localizações...' :
                                                (selectedProduct?.mudarLocal && !entidadeId && !isInternalMovement) ? 'Selecione primeiro uma entidade' :
                                                    'Selecione uma localização'}
                                        </option>
                                        {!loadingLocalizacoes && Array.isArray(localizacoes) && localizacoes.map((localizacao) => (
                                            <option key={localizacao.id} value={localizacao.id}>
                                                {localizacao.nome}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* Departamento */}
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                                        Departamento *
                                    </label>
                                    <select
                                        value={departamentoId}
                                        onChange={(e) => setDepartamentoId(e.target.value)}
                                        disabled={loadingDepartamentos || !localizacaoId}
                                        className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-300 disabled:bg-gray-100 disabled:cursor-not-allowed"
                                    >
                                        <option value="">
                                            {loadingDepartamentos ? 'Carregando departamentos...' : !localizacaoId ? 'Selecione primeiro uma localização' : 'Selecione um departamento'}
                                        </option>
                                        {!loadingDepartamentos && Array.isArray(departamentos) && departamentos.map((departamento) => (
                                            <option key={departamento.id} value={departamento.id}>
                                                {departamento.nome}
                                            </option>
                                        ))}
                                    </select>
                                </div>


                                {/* Responsável */}
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                                        Responsável pela Entrega *
                                    </label>
                                    <input
                                        type="text"
                                        value={responsavelEntrega}
                                        onChange={(e) => setResponsavelEntrega(e.target.value)}
                                        placeholder="Digite o nome do responsável"
                                        className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-300"
                                    />
                                </div>

                                {/* Email do Responsável */}
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                                        Email do Responsável *
                                    </label>
                                    <input
                                        type="email"
                                        value={emailResponsavelEntrega}
                                        onChange={(e) => setEmailResponsavelEntrega(e.target.value)}
                                        placeholder="Digite o email do responsável"
                                        className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-300"
                                    />
                                </div>

                                {/* Observação */}
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                                        Observação
                                    </label>
                                    <textarea
                                        value={observacao}
                                        onChange={(e) => setObservacao(e.target.value)}
                                        rows={3}
                                        placeholder="Digite uma observação (opcional)"
                                        className="w-full px-4 py-3 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-300 resize-none"
                                    />
                                </div>

                                {/* Upload de Imagens */}
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                                        Imagens da Movimentação
                                    </label>
                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                        {/* Foto 1 */}
                                        <div className="space-y-2">
                                            <label className="block text-xs font-medium text-gray-600">Foto 1</label>
                                            <div className="relative">
                                                {previewFoto1 ? (
                                                    <div className="relative">
                                                        <img
                                                            src={previewFoto1}
                                                            alt="Preview"
                                                            className="w-full h-32 cursor-zoom-in object-cover rounded-2xl"
                                                            onDoubleClick={() => openImageModal(previewFoto1, 'Pré-visualização — Foto 1')}
                                                            title="Duplo clique para ampliar"
                                                        />
                                                        <button
                                                            type="button"
                                                            onClick={() => handleRemoveImage(setFoto1, setPreviewFoto1)}
                                                            className="absolute top-2 right-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600 transition-colors duration-200"
                                                        >
                                                            <XMarkIcon className="w-3 h-3" />
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <div className="flex flex-col items-center justify-center w-full h-32 border-2 border-gray-300 border-dashed rounded-2xl hover:bg-gray-50 transition-all duration-200 px-2 py-2">
                                                        <PhotoIcon className="w-8 h-8 text-gray-400 mb-1" />
                                                        <p className="text-xs text-gray-500 mb-2">Adicionar foto</p>
                                                        <div className="flex flex-wrap gap-2 justify-center">
                                                            <label htmlFor="mov-new-f1-gal" className="cursor-pointer rounded-lg bg-gray-100 px-2 py-1 text-xs font-medium text-gray-700 hover:bg-gray-200">Galeria</label>
                                                            <label htmlFor="mov-new-f1-cam" className="cursor-pointer rounded-lg bg-blue-100 px-2 py-1 text-xs font-medium text-blue-800 hover:bg-blue-200">Câmera</label>
                                                        </div>
                                                        <input
                                                            id="mov-new-f1-gal"
                                                            type="file"
                                                            accept="image/*"
                                                            onChange={(e) => {
                                                                const f = e.target.files?.[0]
                                                                if (f) handleImageUpload(f, setFoto1, setPreviewFoto1)
                                                                e.target.value = ''
                                                            }}
                                                            className="hidden"
                                                        />
                                                        <input
                                                            id="mov-new-f1-cam"
                                                            type="file"
                                                            accept="image/*"
                                                            capture="environment"
                                                            onChange={(e) => {
                                                                const f = e.target.files?.[0]
                                                                if (f) handleImageUpload(f, setFoto1, setPreviewFoto1)
                                                                e.target.value = ''
                                                            }}
                                                            className="hidden"
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        {/* Foto 2 */}
                                        <div className="space-y-2">
                                            <label className="block text-xs font-medium text-gray-600">Foto 2</label>
                                            <div className="relative">
                                                {previewFoto2 ? (
                                                    <div className="relative">
                                                        <img
                                                            src={previewFoto2}
                                                            alt="Preview"
                                                            className="w-full h-32 cursor-zoom-in object-cover rounded-2xl"
                                                            onDoubleClick={() => openImageModal(previewFoto2, 'Pré-visualização — Foto 2')}
                                                            title="Duplo clique para ampliar"
                                                        />
                                                        <button
                                                            type="button"
                                                            onClick={() => handleRemoveImage(setFoto2, setPreviewFoto2)}
                                                            className="absolute top-2 right-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600 transition-colors duration-200"
                                                        >
                                                            <XMarkIcon className="w-3 h-3" />
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <div className="flex flex-col items-center justify-center w-full h-32 border-2 border-gray-300 border-dashed rounded-2xl hover:bg-gray-50 transition-all duration-200 px-2 py-2">
                                                        <PhotoIcon className="w-8 h-8 text-gray-400 mb-1" />
                                                        <p className="text-xs text-gray-500 mb-2">Adicionar foto</p>
                                                        <div className="flex flex-wrap gap-2 justify-center">
                                                            <label htmlFor="mov-new-f2-gal" className="cursor-pointer rounded-lg bg-gray-100 px-2 py-1 text-xs font-medium text-gray-700 hover:bg-gray-200">Galeria</label>
                                                            <label htmlFor="mov-new-f2-cam" className="cursor-pointer rounded-lg bg-blue-100 px-2 py-1 text-xs font-medium text-blue-800 hover:bg-blue-200">Câmera</label>
                                                        </div>
                                                        <input
                                                            id="mov-new-f2-gal"
                                                            type="file"
                                                            accept="image/*"
                                                            onChange={(e) => {
                                                                const f = e.target.files?.[0]
                                                                if (f) handleImageUpload(f, setFoto2, setPreviewFoto2)
                                                                e.target.value = ''
                                                            }}
                                                            className="hidden"
                                                        />
                                                        <input
                                                            id="mov-new-f2-cam"
                                                            type="file"
                                                            accept="image/*"
                                                            capture="environment"
                                                            onChange={(e) => {
                                                                const f = e.target.files?.[0]
                                                                if (f) handleImageUpload(f, setFoto2, setPreviewFoto2)
                                                                e.target.value = ''
                                                            }}
                                                            className="hidden"
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        {/* Foto 3 */}
                                        <div className="space-y-2">
                                            <label className="block text-xs font-medium text-gray-600">Foto 3</label>
                                            <div className="relative">
                                                {previewFoto3 ? (
                                                    <div className="relative">
                                                        <img
                                                            src={previewFoto3}
                                                            alt="Preview"
                                                            className="w-full h-32 cursor-zoom-in object-cover rounded-2xl"
                                                            onDoubleClick={() => openImageModal(previewFoto3, 'Pré-visualização — Foto 3')}
                                                            title="Duplo clique para ampliar"
                                                        />
                                                        <button
                                                            type="button"
                                                            onClick={() => handleRemoveImage(setFoto3, setPreviewFoto3)}
                                                            className="absolute top-2 right-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600 transition-colors duration-200"
                                                        >
                                                            <XMarkIcon className="w-3 h-3" />
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <div className="flex flex-col items-center justify-center w-full h-32 border-2 border-gray-300 border-dashed rounded-2xl hover:bg-gray-50 transition-all duration-200 px-2 py-2">
                                                        <PhotoIcon className="w-8 h-8 text-gray-400 mb-1" />
                                                        <p className="text-xs text-gray-500 mb-2">Adicionar foto</p>
                                                        <div className="flex flex-wrap gap-2 justify-center">
                                                            <label htmlFor="mov-new-f3-gal" className="cursor-pointer rounded-lg bg-gray-100 px-2 py-1 text-xs font-medium text-gray-700 hover:bg-gray-200">Galeria</label>
                                                            <label htmlFor="mov-new-f3-cam" className="cursor-pointer rounded-lg bg-blue-100 px-2 py-1 text-xs font-medium text-blue-800 hover:bg-blue-200">Câmera</label>
                                                        </div>
                                                        <input
                                                            id="mov-new-f3-gal"
                                                            type="file"
                                                            accept="image/*"
                                                            onChange={(e) => {
                                                                const f = e.target.files?.[0]
                                                                if (f) handleImageUpload(f, setFoto3, setPreviewFoto3)
                                                                e.target.value = ''
                                                            }}
                                                            className="hidden"
                                                        />
                                                        <input
                                                            id="mov-new-f3-cam"
                                                            type="file"
                                                            accept="image/*"
                                                            capture="environment"
                                                            onChange={(e) => {
                                                                const f = e.target.files?.[0]
                                                                if (f) handleImageUpload(f, setFoto3, setPreviewFoto3)
                                                                e.target.value = ''
                                                            }}
                                                            className="hidden"
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Botões */}
                        <div className="flex shrink-0 items-center justify-end space-x-4 border-t border-gray-200 bg-white p-6">
                            <button
                                onClick={closeModal}
                                className="px-6 py-3 border border-gray-300 rounded-2xl text-sm font-semibold text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-all duration-300"
                            >
                                Cancelar
                            </button>
                            <button
                                onClick={handleSaveMovimentacao}
                                disabled={isSubmitting}
                                className="group relative inline-flex items-center px-6 py-3 border border-transparent rounded-2xl shadow-lg text-sm font-semibold text-white bg-gradient-to-r from-indigo-600 via-blue-700 to-blue-700 hover:from-indigo-700 hover:via-blue-800 hover:to-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-all duration-300 transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                <div className="relative z-10 flex items-center">
                                    {isSubmitting ? (
                                        <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                                    ) : (
                                        <PlusIcon className="w-4 h-4 mr-2" />
                                    )}
                                    <span>{isSubmitting ? 'Salvando...' : (isEditMode ? 'Atualizar' : 'Criar')}</span>
                                </div>
                                <div className="absolute inset-0 bg-gradient-to-r from-indigo-500/10 to-blue-500/10 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal de Visualização */}
            {isViewModalOpen && viewingMovimentacao && (
                <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center p-4 z-50">
                    <div className="relative flex max-h-[90vh] w-full max-w-5xl flex-col overflow-hidden rounded-3xl bg-white shadow-2xl">
                        {/* Header do Modal */}
                        <div className="relative shrink-0 bg-gradient-to-r from-indigo-600 via-blue-700 to-blue-700 rounded-t-3xl p-6">
                            <div className="absolute inset-0 bg-gradient-to-r from-indigo-500/10 to-blue-500/10 rounded-t-3xl"></div>
                            <div className="relative flex items-center justify-between">
                                <div className="flex items-center">
                                    <div className="p-3 rounded-2xl bg-white/20 backdrop-blur-sm mr-4">
                                        <EyeIcon className="w-8 h-8 text-white" />
                                    </div>
                                    <div>
                                        <h2 className="text-2xl font-bold text-white">
                                            Detalhes da Movimentação
                                        </h2>
                                        <p className="text-indigo-100 mt-1">
                                            {viewingMovimentacao.produto_modelo} - Código NET: #{viewingMovimentacao.produto_codigo_net}
                                        </p>
                                    </div>
                                </div>
                                <button
                                    onClick={closeViewModal}
                                    className="p-2 rounded-full bg-white/20 backdrop-blur-sm text-white hover:bg-white/30 transition-colors duration-200"
                                >
                                    <XMarkIcon className="w-6 h-6" />
                                </button>
                            </div>
                        </div>

                        {/* Conteúdo do Modal */}
                        <div className="min-h-0 flex-1 overflow-y-auto p-6">
                            <div className="space-y-6">
                                {/* Informações Principais - Destaque */}
                                <div className="bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 rounded-2xl p-6 text-white">
                                    <div className="flex items-center mb-4">
                                        <div className="p-3 rounded-xl bg-white/20 backdrop-blur-sm mr-3">
                                            <InformationCircleIcon className="w-6 h-6 text-white" />
                                        </div>
                                        <div>
                                            <h3 className="text-xl font-bold text-white">Informações Principais</h3>
                                            <p className="text-blue-100 text-sm">Dados essenciais da movimentação</p>
                                        </div>
                                    </div>

                                    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                                        {/* Código NET - DESTAQUE MÁXIMO */}
                                        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center">
                                            <div className="text-3xl font-bold mb-2">#{viewingMovimentacao.produto_codigo_net}</div>
                                            <div className="text-sm text-blue-100">Código NET</div>
                                        </div>

                                        {/* Responsável */}
                                        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4">
                                            <div className="flex items-center mb-2">
                                                <UserIcon className="w-5 h-5 mr-2" />
                                                <span className="text-sm text-blue-100">Responsável</span>
                                            </div>
                                            <div className="font-semibold text-lg">{viewingMovimentacao.movimentacao_responsavel_entrega}</div>
                                            <div className="text-sm text-blue-100">{viewingMovimentacao.movimentacao_email_responsavel_entrega}</div>
                                        </div>

                                        {/* Local Atual */}
                                        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4">
                                            <div className="flex items-center mb-2">
                                                <MapPinIcon className="w-5 h-5 mr-2" />
                                                <span className="text-sm text-blue-100">Local Atual</span>
                                            </div>
                                            <div className="font-semibold text-lg">{viewingMovimentacao.local_nome || 'N/A'}</div>
                                            <div className="text-sm text-blue-100">{viewingMovimentacao.departamento_nome || 'N/A'}</div>
                                        </div>

                                        {/* Status */}
                                        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center">
                                            <div className="flex items-center justify-center mb-2">
                                                {(() => {
                                                    const tipo = tiposMovimentacao.find(t => t.value === viewingMovimentacao.movimentacao_tipo)
                                                    const IconComponent = tipo?.icon || TruckIcon
                                                    return <IconComponent className="w-5 h-5 mr-2" />
                                                })()}
                                                <span className="text-sm text-blue-100">Status</span>
                                            </div>
                                            <div className="font-semibold text-lg">
                                                {(() => {
                                                    const tipo = tiposMovimentacao.find(t => t.value === viewingMovimentacao.movimentacao_tipo)
                                                    return tipo?.label || 'Desconhecido'
                                                })()}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Origem e Destino - Destaque Principal */}
                                <div className="bg-gradient-to-r from-blue-50 via-indigo-50 to-purple-50 rounded-2xl p-6 border border-blue-200">
                                    <div className="flex items-center mb-4">
                                        <div className="p-3 rounded-xl bg-gradient-to-r from-blue-500 to-indigo-600 shadow-lg mr-3">
                                            <ArrowsRightLeftIcon className="w-6 h-6 text-white" />
                                        </div>
                                        <div>
                                            <h3 className="text-xl font-bold text-gray-900">Movimentação</h3>
                                            <p className="text-gray-600 text-sm">Origem e destino da movimentação</p>
                                        </div>
                                    </div>

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        {/* Origem */}
                                        <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100">
                                            <div className="flex items-center mb-3">
                                                <div className="p-2 rounded-lg bg-red-100 text-red-700 mr-2">
                                                    <ArrowUpIcon className="w-4 h-4" />
                                                </div>
                                                <h4 className="text-lg font-semibold text-gray-900">Origem</h4>
                                            </div>
                                            <div className="space-y-2">
                                                <div>
                                                    <span className="text-sm font-medium text-gray-500">Entidade:</span>
                                                    <p className="text-gray-900 font-semibold">{viewingMovimentacao.entidade_origem_nome || 'Não informado'}</p>
                                                </div>
                                                <div>
                                                    <span className="text-sm font-medium text-gray-500">Local:</span>
                                                    <p className="text-gray-900">{viewingMovimentacao.local_origem_nome || 'Não informado'}</p>
                                                </div>
                                                <div>
                                                    <span className="text-sm font-medium text-gray-500">Departamento:</span>
                                                    <p className="text-gray-900">{viewingMovimentacao.departamento_origem_nome || 'Não informado'}</p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Destino */}
                                        <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100">
                                            <div className="flex items-center mb-3">
                                                <div className="p-2 rounded-lg bg-green-100 text-green-700 mr-2">
                                                    <ArrowDownIcon className="w-4 h-4" />
                                                </div>
                                                <h4 className="text-lg font-semibold text-gray-900">Destino</h4>
                                            </div>
                                            <div className="space-y-2">
                                                <div>
                                                    <span className="text-sm font-medium text-gray-500">Entidade:</span>
                                                    <p className="text-gray-900 font-semibold">{viewingMovimentacao.entidade_destino_nome || 'Não informado'}</p>
                                                </div>
                                                <div>
                                                    <span className="text-sm font-medium text-gray-500">Local:</span>
                                                    <p className="text-gray-900">{viewingMovimentacao.local_nome || 'Não informado'}</p>
                                                </div>
                                                <div>
                                                    <span className="text-sm font-medium text-gray-500">Departamento:</span>
                                                    <p className="text-gray-900">{viewingMovimentacao.departamento_nome || 'Não informado'}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Informações do Produto */}
                                <div className="bg-gradient-to-r from-green-50 via-emerald-50 to-green-50 rounded-2xl p-6 border border-green-200">
                                    <div className="flex items-center mb-4">
                                        <div className="p-3 rounded-xl bg-gradient-to-r from-green-500 to-emerald-600 shadow-lg mr-3">
                                            <TruckIcon className="w-6 h-6 text-white" />
                                        </div>
                                        <div>
                                            <h3 className="text-xl font-bold text-gray-900">Produto</h3>
                                            <p className="text-gray-600 text-sm">Detalhes do produto movimentado</p>
                                        </div>
                                    </div>

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        {/* Produto */}
                                        <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100">
                                            <div className="flex items-center mb-3">
                                                <div className="p-2 rounded-lg bg-green-100 text-green-700 mr-2">
                                                    <TruckIcon className="w-4 h-4" />
                                                </div>
                                                <h4 className="text-lg font-semibold text-gray-900">Produto</h4>
                                            </div>
                                            <div className="space-y-2">
                                                <div>
                                                    <span className="text-sm font-medium text-gray-500">Modelo:</span>
                                                    <p className="text-gray-900 font-semibold">{viewingMovimentacao.produto_modelo}</p>
                                                </div>
                                                <div>
                                                    <span className="text-sm font-medium text-gray-500">Serial:</span>
                                                    <p className="text-gray-900 font-semibold">{viewingMovimentacao.produto_serial}</p>
                                                </div>
                                                <div>
                                                    <span className="text-sm font-medium text-gray-500">Contador:</span>
                                                    <p className="text-gray-900">{viewingMovimentacao.movimentacao_contador}</p>
                                                </div>
                                                <div>
                                                    <span className="text-sm font-medium text-gray-500">Condição:</span>
                                                    <p className="text-gray-900">{viewingMovimentacao.produto_condicao === 0 ? 'Novo' : 'Usado'}</p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Equipamento */}
                                        <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100">
                                            <div className="flex items-center mb-3">
                                                <div className="p-2 rounded-lg bg-blue-100 text-blue-700 mr-2">
                                                    <BuildingOfficeIcon className="w-4 h-4" />
                                                </div>
                                                <h4 className="text-lg font-semibold text-gray-900">Equipamento</h4>
                                            </div>
                                            <div className="space-y-2">
                                                <div>
                                                    <span className="text-sm font-medium text-gray-500">Nome:</span>
                                                    <p className="text-gray-900 font-semibold">{viewingMovimentacao.equipamento_nome}</p>
                                                </div>
                                                <div>
                                                    <span className="text-sm font-medium text-gray-500">Formato:</span>
                                                    <p className="text-gray-900">{viewingMovimentacao.equipamento_formato_nome}</p>
                                                </div>
                                                <div>
                                                    <span className="text-sm font-medium text-gray-500">Marca:</span>
                                                    <p className="text-gray-900">{viewingMovimentacao.marca_nome}</p>
                                                </div>
                                                <div>
                                                    <span className="text-sm font-medium text-gray-500">Código NET:</span>
                                                    <p className="text-gray-900">{viewingMovimentacao.produto_codigo_net}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Imagens da Movimentação */}
                                {(viewingMovimentacao.movimentacao_foto1 || viewingMovimentacao.movimentacao_foto2 || viewingMovimentacao.movimentacao_foto3) && (
                                    <div className="bg-gradient-to-r from-gray-50 to-blue-50 rounded-2xl p-6 border border-gray-200">
                                        <div className="flex items-center mb-4">
                                            <div className="p-3 rounded-xl bg-gradient-to-r from-gray-500 to-blue-600 shadow-lg mr-3">
                                                <PhotoIcon className="w-6 h-6 text-white" />
                                            </div>
                                            <div>
                                                <h3 className="text-xl font-bold text-gray-900">Imagens da Movimentação</h3>
                                                <p className="text-gray-600 text-sm">Fotos registradas durante a movimentação</p>
                                            </div>
                                        </div>
                                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                            {viewingMovimentacao.movimentacao_foto1 && (
                                                <div className="relative group bg-white rounded-xl p-3 shadow-sm border border-gray-100 cursor-pointer hover:shadow-lg transition-all duration-300" onClick={() => openImageModal(
                                                    viewingMovimentacao.movimentacao_foto1_path ?
                                                        `data:image/webp;base64,${viewingMovimentacao.movimentacao_foto1_path}` :
                                                        `/movimentacao/${viewingMovimentacao.movimentacao_foto1}`,
                                                    'Foto 1 da Movimentação'
                                                )}>
                                                    <div className="relative overflow-hidden rounded-lg">
                                                        <img
                                                            src={viewingMovimentacao.movimentacao_foto1_path ?
                                                                `data:image/webp;base64,${viewingMovimentacao.movimentacao_foto1_path}` :
                                                                `/movimentacao/${viewingMovimentacao.movimentacao_foto1}`
                                                            }
                                                            alt="Foto 1 da movimentação"
                                                            className="w-full h-32 object-cover transition-transform duration-300 group-hover:scale-105"
                                                            onError={(e) => {
                                                                console.error('Erro ao carregar imagem 1:', e)
                                                                e.target.style.display = 'none'
                                                            }}
                                                        />
                                                        <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-300 rounded-lg flex items-center justify-center">
                                                            <div className="opacity-0 group-hover:opacity-100 transition-all duration-300">
                                                                <PhotoIcon className="w-8 h-8 text-white" />
                                                                <p className="text-white text-sm mt-1">Clique para ampliar</p>
                                                            </div>
                                                        </div>
                                                        <div className="absolute top-2 left-2 bg-blue-600 text-white text-xs px-2 py-1 rounded-full font-medium">
                                                            Foto 1
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {viewingMovimentacao.movimentacao_foto2 && (
                                                <div className="relative group bg-white rounded-xl p-3 shadow-sm border border-gray-100 cursor-pointer hover:shadow-lg transition-all duration-300" onClick={() => openImageModal(
                                                    viewingMovimentacao.movimentacao_foto2_path ?
                                                        `data:image/webp;base64,${viewingMovimentacao.movimentacao_foto2_path}` :
                                                        `/movimentacao/${viewingMovimentacao.movimentacao_foto2}`,
                                                    'Foto 2 da Movimentação'
                                                )}>
                                                    <div className="relative overflow-hidden rounded-lg">
                                                        <img
                                                            src={viewingMovimentacao.movimentacao_foto2_path ?
                                                                `data:image/webp;base64,${viewingMovimentacao.movimentacao_foto2_path}` :
                                                                `/movimentacao/${viewingMovimentacao.movimentacao_foto2}`
                                                            }
                                                            alt="Foto 2 da movimentação"
                                                            className="w-full h-32 object-cover transition-transform duration-300 group-hover:scale-105"
                                                            onError={(e) => {
                                                                console.error('Erro ao carregar imagem 2:', e)
                                                                e.target.style.display = 'none'
                                                            }}
                                                        />
                                                        <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-300 rounded-lg flex items-center justify-center">
                                                            <div className="opacity-0 group-hover:opacity-100 transition-all duration-300">
                                                                <PhotoIcon className="w-8 h-8 text-white" />
                                                                <p className="text-white text-sm mt-1">Clique para ampliar</p>
                                                            </div>
                                                        </div>
                                                        <div className="absolute top-2 left-2 bg-blue-600 text-white text-xs px-2 py-1 rounded-full font-medium">
                                                            Foto 2
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {viewingMovimentacao.movimentacao_foto3 && (
                                                <div className="relative group bg-white rounded-xl p-3 shadow-sm border border-gray-100 cursor-pointer hover:shadow-lg transition-all duration-300" onClick={() => openImageModal(
                                                    viewingMovimentacao.movimentacao_foto3_path ?
                                                        `data:image/webp;base64,${viewingMovimentacao.movimentacao_foto3_path}` :
                                                        `/movimentacao/${viewingMovimentacao.movimentacao_foto3}`,
                                                    'Foto 3 da Movimentação'
                                                )}>
                                                    <div className="relative overflow-hidden rounded-lg">
                                                        <img
                                                            src={viewingMovimentacao.movimentacao_foto3_path ?
                                                                `data:image/webp;base64,${viewingMovimentacao.movimentacao_foto3_path}` :
                                                                `/movimentacao/${viewingMovimentacao.movimentacao_foto3}`
                                                            }
                                                            alt="Foto 3 da movimentação"
                                                            className="w-full h-32 object-cover transition-transform duration-300 group-hover:scale-105"
                                                            onError={(e) => {
                                                                console.error('Erro ao carregar imagem 3:', e)
                                                                e.target.style.display = 'none'
                                                            }}
                                                        />
                                                        <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-300 rounded-lg flex items-center justify-center">
                                                            <div className="opacity-0 group-hover:opacity-100 transition-all duration-300">
                                                                <PhotoIcon className="w-8 h-8 text-white" />
                                                                <p className="text-white text-sm mt-1">Clique para ampliar</p>
                                                            </div>
                                                        </div>
                                                        <div className="absolute top-2 left-2 bg-blue-600 text-white text-xs px-2 py-1 rounded-full font-medium">
                                                            Foto 3
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}

                                {/* Relatório da Movimentação */}
                                {viewingMovimentacao.movimentacao_comprovante_path && (
                                    <div className="bg-gradient-to-r from-purple-50 via-violet-50 to-purple-50 rounded-2xl p-6 border border-purple-200">
                                        <div className="flex items-center mb-4">
                                            <div className="p-3 rounded-xl bg-gradient-to-r from-purple-500 to-violet-600 shadow-lg mr-3">
                                                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                                </svg>
                                            </div>
                                            <div>
                                                <h3 className="text-xl font-bold text-gray-900">Relatório da Movimentação</h3>
                                                <p className="text-gray-600 text-sm">Comprovante gerado para esta movimentação</p>
                                            </div>
                                        </div>
                                        <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100">
                                            <div className="flex items-center justify-between">
                                                <div className="flex items-center space-x-3">
                                                    <div className="p-2 rounded-lg bg-purple-100 text-purple-700">
                                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                                        </svg>
                                                    </div>
                                                    <div>
                                                        <p className="text-sm font-medium text-gray-900">
                                                            {viewingMovimentacao.movimentacao_comprovante || 'relatorio.pdf'}
                                                        </p>
                                                        <p className="text-xs text-gray-500">Arquivo PDF</p>
                                                    </div>
                                                </div>
                                                <button
                                                    onClick={() => downloadRelatorio(viewingMovimentacao.movimentacao_comprovante_path, viewingMovimentacao.movimentacao_comprovante)}
                                                    className="group relative inline-flex items-center px-4 py-2 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-gradient-to-r from-purple-600 to-violet-600 hover:from-purple-700 hover:to-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 transition-all duration-300 transform hover:scale-105"
                                                >
                                                    <div className="relative z-10 flex items-center">
                                                        <svg className="w-4 h-4 mr-2 group-hover:scale-110 transition-transform duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                                        </svg>
                                                        <span>Baixar Relatório</span>
                                                    </div>
                                                    <div className="absolute inset-0 bg-gradient-to-r from-purple-500/10 to-violet-500/10 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Informações Adicionais */}
                                <div className="bg-gradient-to-r from-yellow-50 via-orange-50 to-yellow-50 rounded-2xl p-6 border border-yellow-200">
                                    <div className="flex items-center mb-4">
                                        <div className="p-3 rounded-xl bg-gradient-to-r from-yellow-500 to-orange-600 shadow-lg mr-3">
                                            <InformationCircleIcon className="w-6 h-6 text-white" />
                                        </div>
                                        <div>
                                            <h3 className="text-xl font-bold text-gray-900">Informações Adicionais</h3>
                                            <p className="text-gray-600 text-sm">Observações e dados de controle</p>
                                        </div>
                                    </div>

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        {/* Observação */}
                                        <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100">
                                            <div className="flex items-center mb-3">
                                                <div className="p-2 rounded-lg bg-yellow-100 text-yellow-700 mr-2">
                                                    <InformationCircleIcon className="w-4 h-4" />
                                                </div>
                                                <h4 className="text-lg font-semibold text-gray-900">Observação</h4>
                                            </div>
                                            <div>
                                                <p className="text-gray-900 text-sm">{viewingMovimentacao.movimentacao_observacao || 'Sem observação'}</p>
                                            </div>
                                        </div>

                                        {/* Datas */}
                                        <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100">
                                            <div className="flex items-center mb-3">
                                                <div className="p-2 rounded-lg bg-orange-100 text-orange-700 mr-2">
                                                    <CalendarIcon className="w-4 h-4" />
                                                </div>
                                                <h4 className="text-lg font-semibold text-gray-900">Datas</h4>
                                            </div>
                                            <div className="space-y-2">
                                                <div>
                                                    <span className="text-sm font-medium text-gray-500">Data da Movimentação:</span>
                                                    <p className="text-gray-900 text-sm">{new Date(viewingMovimentacao.movimentacao_data_movimentacao).toLocaleString('pt-BR')}</p>
                                                </div>
                                                <div>
                                                    <span className="text-sm font-medium text-gray-500">Responsável:</span>
                                                    <p className="text-gray-900 text-sm">{viewingMovimentacao.movimentacao_responsavel_entrega || 'Não informado'}</p>
                                                </div>
                                                <div>
                                                    <span className="text-sm font-medium text-gray-500">Email:</span>
                                                    <p className="text-gray-900 text-sm">{viewingMovimentacao.movimentacao_email_responsavel_entrega || 'Não informado'}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Footer do Modal */}
                        <div className="flex shrink-0 items-center justify-end border-t border-gray-200 p-6">
                            <button
                                onClick={closeViewModal}
                                className="px-6 py-3 border border-gray-300 rounded-2xl text-sm font-semibold text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-all duration-300"
                            >
                                Fechar
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal de Edição */}
            {isEditModalOpen && editMovimentacao && (
                <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center p-4 z-50">
                    <div className="relative flex max-h-[90vh] w-full max-w-4xl flex-col overflow-hidden rounded-3xl bg-white shadow-2xl">
                        {/* Header do Modal */}
                        <div className="relative shrink-0 bg-gradient-to-r from-blue-600 via-blue-700 to-blue-700 rounded-t-3xl p-6">
                            <div className="absolute inset-0 bg-gradient-to-r from-blue-500/10 to-blue-500/10 rounded-t-3xl"></div>
                            <div className="relative flex items-center justify-between">
                                <div className="flex items-center">
                                    <div className="p-3 rounded-2xl bg-white/20 backdrop-blur-sm mr-4">
                                        <PencilSquareIcon className="w-8 h-8 text-white" />
                                    </div>
                                    <div>
                                        <h2 className="text-2xl font-bold text-white">
                                            Editar Movimentação
                                        </h2>
                                        <p className="text-blue-100 mt-1">
                                            {editMovimentacao.produto_modelo} - Código NET: #{editMovimentacao.produto_codigo_net}
                                        </p>
                                    </div>
                                </div>
                                <button
                                    onClick={closeEditModal}
                                    className="p-2 rounded-full bg-white/20 backdrop-blur-sm text-white hover:bg-white/30 transition-colors duration-200"
                                >
                                    <XMarkIcon className="w-6 h-6" />
                                </button>
                            </div>
                        </div>

                        {/* Conteúdo do Modal */}
                        <div className="min-h-0 flex-1 overflow-y-auto p-6">
                            <div className="space-y-6">
                                {/* Informações não editáveis */}
                                <div className="bg-gray-50 rounded-2xl p-6">
                                    <h3 className="text-lg font-semibold text-gray-900 mb-4">Informações da Movimentação</h3>
                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Produto</label>
                                            <p className="text-gray-900">{editMovimentacao.produto_modelo}</p>
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Código NET</label>
                                            <p className="text-gray-900">#{editMovimentacao.produto_codigo_net}</p>
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Entidade de Destino</label>
                                            <p className="text-gray-900">{editMovimentacao.entidade_destino_nome}</p>
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Departamento Atual</label>
                                            <p className="text-gray-900">{editMovimentacao.departamento_nome || editMovimentacao.departamento_atual_nome || editMovimentacao.departamento_destino_nome || editMovimentacao.departamento_origem_nome || 'N/A'}</p>
                                        </div>
                                    </div>
                                </div>

                                {/* Campos editáveis */}
                                <div className="space-y-6">
                                    <h3 className="text-lg font-semibold text-gray-900">Campos Editáveis</h3>

                                    {/* Localização e Departamento */}
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                Localização <span className="text-red-500">*</span>
                                            </label>
                                            <select
                                                value={editLocalizacaoId}
                                                onChange={(e) => {
                                                    setEditLocalizacaoId(e.target.value)
                                                    setEditDepartamentoId('')
                                                    if (e.target.value) {
                                                        loadEditDepartamentos(e.target.value)
                                                    }
                                                }}
                                                className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-300"
                                                disabled={loadingEditLocalizacoes}
                                            >
                                                <option value="">Selecione uma localização</option>
                                                {editLocalizacoes.map((localizacao) => (
                                                    <option key={localizacao.id} value={localizacao.id}>
                                                        {localizacao.nome}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                Departamento <span className="text-red-500">*</span>
                                            </label>
                                            <select
                                                value={editDepartamentoId}
                                                onChange={(e) => setEditDepartamentoId(e.target.value)}
                                                className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-300"
                                                disabled={loadingEditDepartamentos || !editLocalizacaoId}
                                            >
                                                <option value="">Selecione um departamento</option>
                                                {editDepartamentos.map((departamento) => (
                                                    <option key={departamento.id} value={departamento.id}>
                                                        {departamento.nome}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    {/* Responsável e Email */}
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                Responsável pela Entrega
                                            </label>
                                            <input
                                                type="text"
                                                value={editResponsavelEntrega}
                                                onChange={(e) => setEditResponsavelEntrega(e.target.value)}
                                                className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-300"
                                                placeholder="Nome do responsável"
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                Email do Responsável
                                            </label>
                                            <input
                                                type="email"
                                                value={editEmailResponsavelEntrega}
                                                onChange={(e) => setEditEmailResponsavelEntrega(e.target.value)}
                                                className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-300"
                                                placeholder="email@exemplo.com"
                                            />
                                        </div>
                                    </div>

                                    {/* Observação */}
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">Observação</label>
                                        <textarea
                                            value={editObservacao}
                                            onChange={(e) => setEditObservacao(e.target.value)}
                                            rows={3}
                                            className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-300"
                                            placeholder="Observações adicionais..."
                                        />
                                    </div>
                                </div>

                                {/* Upload de Fotos */}
                                <div className="space-y-4">
                                    <h3 className="text-lg font-semibold text-gray-900">Fotos da Movimentação</h3>
                                    <p className="text-sm text-gray-600">Você pode alterar as fotos existentes ou manter as atuais.</p>

                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                                        {/* Foto 1 */}
                                        <div className="space-y-3">
                                            <label className="block text-sm font-medium text-gray-700">Foto 1</label>
                                            <div className="border-2 border-dashed border-gray-300 rounded-xl p-4 text-center hover:border-blue-400 transition-colors duration-300">
                                                {editPreviewFoto1 ? (
                                                    <div className="space-y-2">
                                                        <img
                                                            src={editPreviewFoto1}
                                                            alt="Preview"
                                                            className="w-full h-32 cursor-zoom-in object-cover rounded-lg"
                                                            onDoubleClick={() => openImageModal(editPreviewFoto1, 'Edição — Foto 1')}
                                                            title="Duplo clique para ampliar"
                                                        />
                                                        <button
                                                            onClick={() => {
                                                                setEditFoto1(null)
                                                                setEditPreviewFoto1('')
                                                                setEditFoto1Alterada(false)
                                                            }}
                                                            className="text-red-600 text-sm hover:text-red-800"
                                                        >
                                                            Remover
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <div className="space-y-2">
                                                        <PhotoIcon className="w-8 h-8 text-gray-400 mx-auto" />
                                                        <p className="text-sm text-gray-500">Nenhuma foto</p>
                                                    </div>
                                                )}
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={(e) => {
                                                        const f = e.target.files?.[0]
                                                        if (f) handleEditImageUpload(f, setEditFoto1, setEditPreviewFoto1, setEditFoto1Alterada)
                                                        e.target.value = ''
                                                    }}
                                                    className="hidden"
                                                    id="edit-foto1-gal"
                                                />
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    capture="environment"
                                                    onChange={(e) => {
                                                        const f = e.target.files?.[0]
                                                        if (f) handleEditImageUpload(f, setEditFoto1, setEditPreviewFoto1, setEditFoto1Alterada)
                                                        e.target.value = ''
                                                    }}
                                                    className="hidden"
                                                    id="edit-foto1-cam"
                                                />
                                                <div className="flex flex-col gap-2 w-full">
                                                    <label
                                                        htmlFor="edit-foto1-gal"
                                                        className="block w-full px-3 py-2 text-sm text-center text-blue-600 hover:text-blue-800 cursor-pointer border border-blue-300 rounded-lg hover:bg-blue-50 transition-colors duration-300"
                                                    >
                                                        {editPreviewFoto1 ? 'Alterar (galeria)' : 'Galeria'}
                                                    </label>
                                                    <label
                                                        htmlFor="edit-foto1-cam"
                                                        className="block w-full px-3 py-2 text-sm text-center text-white cursor-pointer bg-blue-600 border border-blue-600 rounded-lg hover:bg-blue-700 transition-colors duration-300"
                                                    >
                                                        {editPreviewFoto1 ? 'Alterar (câmera)' : 'Câmera'}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Foto 2 */}
                                        <div className="space-y-3">
                                            <label className="block text-sm font-medium text-gray-700">Foto 2</label>
                                            <div className="border-2 border-dashed border-gray-300 rounded-xl p-4 text-center hover:border-blue-400 transition-colors duration-300">
                                                {editPreviewFoto2 ? (
                                                    <div className="space-y-2">
                                                        <img
                                                            src={editPreviewFoto2}
                                                            alt="Preview"
                                                            className="w-full h-32 cursor-zoom-in object-cover rounded-lg"
                                                            onDoubleClick={() => openImageModal(editPreviewFoto2, 'Edição — Foto 2')}
                                                            title="Duplo clique para ampliar"
                                                        />
                                                        <button
                                                            onClick={() => {
                                                                setEditFoto2(null)
                                                                setEditPreviewFoto2('')
                                                                setEditFoto2Alterada(false)
                                                            }}
                                                            className="text-red-600 text-sm hover:text-red-800"
                                                        >
                                                            Remover
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <div className="space-y-2">
                                                        <PhotoIcon className="w-8 h-8 text-gray-400 mx-auto" />
                                                        <p className="text-sm text-gray-500">Nenhuma foto</p>
                                                    </div>
                                                )}
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={(e) => {
                                                        const f = e.target.files?.[0]
                                                        if (f) handleEditImageUpload(f, setEditFoto2, setEditPreviewFoto2, setEditFoto2Alterada)
                                                        e.target.value = ''
                                                    }}
                                                    className="hidden"
                                                    id="edit-foto2-gal"
                                                />
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    capture="environment"
                                                    onChange={(e) => {
                                                        const f = e.target.files?.[0]
                                                        if (f) handleEditImageUpload(f, setEditFoto2, setEditPreviewFoto2, setEditFoto2Alterada)
                                                        e.target.value = ''
                                                    }}
                                                    className="hidden"
                                                    id="edit-foto2-cam"
                                                />
                                                <div className="flex flex-col gap-2 w-full">
                                                    <label
                                                        htmlFor="edit-foto2-gal"
                                                        className="block w-full px-3 py-2 text-sm text-center text-blue-600 hover:text-blue-800 cursor-pointer border border-blue-300 rounded-lg hover:bg-blue-50 transition-colors duration-300"
                                                    >
                                                        {editPreviewFoto2 ? 'Alterar (galeria)' : 'Galeria'}
                                                    </label>
                                                    <label
                                                        htmlFor="edit-foto2-cam"
                                                        className="block w-full px-3 py-2 text-sm text-center text-white cursor-pointer bg-blue-600 border border-blue-600 rounded-lg hover:bg-blue-700 transition-colors duration-300"
                                                    >
                                                        {editPreviewFoto2 ? 'Alterar (câmera)' : 'Câmera'}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Foto 3 */}
                                        <div className="space-y-3">
                                            <label className="block text-sm font-medium text-gray-700">Foto 3</label>
                                            <div className="border-2 border-dashed border-gray-300 rounded-xl p-4 text-center hover:border-blue-400 transition-colors duration-300">
                                                {editPreviewFoto3 ? (
                                                    <div className="space-y-2">
                                                        <img
                                                            src={editPreviewFoto3}
                                                            alt="Preview"
                                                            className="w-full h-32 cursor-zoom-in object-cover rounded-lg"
                                                            onDoubleClick={() => openImageModal(editPreviewFoto3, 'Edição — Foto 3')}
                                                            title="Duplo clique para ampliar"
                                                        />
                                                        <button
                                                            onClick={() => {
                                                                setEditFoto3(null)
                                                                setEditPreviewFoto3('')
                                                                setEditFoto3Alterada(false)
                                                            }}
                                                            className="text-red-600 text-sm hover:text-red-800"
                                                        >
                                                            Remover
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <div className="space-y-2">
                                                        <PhotoIcon className="w-8 h-8 text-gray-400 mx-auto" />
                                                        <p className="text-sm text-gray-500">Nenhuma foto</p>
                                                    </div>
                                                )}
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={(e) => {
                                                        const f = e.target.files?.[0]
                                                        if (f) handleEditImageUpload(f, setEditFoto3, setEditPreviewFoto3, setEditFoto3Alterada)
                                                        e.target.value = ''
                                                    }}
                                                    className="hidden"
                                                    id="edit-foto3-gal"
                                                />
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    capture="environment"
                                                    onChange={(e) => {
                                                        const f = e.target.files?.[0]
                                                        if (f) handleEditImageUpload(f, setEditFoto3, setEditPreviewFoto3, setEditFoto3Alterada)
                                                        e.target.value = ''
                                                    }}
                                                    className="hidden"
                                                    id="edit-foto3-cam"
                                                />
                                                <div className="flex flex-col gap-2 w-full">
                                                    <label
                                                        htmlFor="edit-foto3-gal"
                                                        className="block w-full px-3 py-2 text-sm text-center text-blue-600 hover:text-blue-800 cursor-pointer border border-blue-300 rounded-lg hover:bg-blue-50 transition-colors duration-300"
                                                    >
                                                        {editPreviewFoto3 ? 'Alterar (galeria)' : 'Galeria'}
                                                    </label>
                                                    <label
                                                        htmlFor="edit-foto3-cam"
                                                        className="block w-full px-3 py-2 text-sm text-center text-white cursor-pointer bg-blue-600 border border-blue-600 rounded-lg hover:bg-blue-700 transition-colors duration-300"
                                                    >
                                                        {editPreviewFoto3 ? 'Alterar (câmera)' : 'Câmera'}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Footer do Modal */}
                        <div className="flex shrink-0 items-center justify-end space-x-4 border-t border-gray-200 p-6">
                            <button
                                onClick={closeEditModal}
                                className="px-6 py-3 border border-gray-300 rounded-2xl text-sm font-semibold text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-all duration-300"
                            >
                                Cancelar
                            </button>
                            <button
                                onClick={handleSaveEdit}
                                disabled={isSubmittingEdit}
                                className="px-6 py-3 border border-transparent rounded-2xl text-sm font-semibold text-white bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                {isSubmittingEdit ? (
                                    <div className="flex items-center space-x-2">
                                        <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                                        <span>Salvando...</span>
                                    </div>
                                ) : (
                                    'Salvar Alterações'
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {isExportModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center p-4 z-50">
                    <div className="relative bg-white rounded-3xl shadow-2xl max-w-md w-full">
                        <div className="relative rounded-t-3xl p-6 bg-gradient-to-r from-emerald-600 via-teal-700 to-teal-700">
                            <div className="relative flex items-center justify-between">
                                <h2 className="text-2xl font-bold text-white">
                                    Exportar e enviar por e-mail
                                </h2>
                                <button
                                    onClick={() => setIsExportModalOpen(false)}
                                    className="p-2 rounded-full bg-white/20 backdrop-blur-sm text-white hover:bg-white/30 transition-colors duration-200"
                                >
                                    <XMarkIcon className="w-6 h-6" />
                                </button>
                            </div>
                        </div>
                        <div className="p-6">
                            <p className="text-sm text-gray-500 mb-6 text-center">
                                Enviar {idsSelecionados.length} item(ns) para {emailUsuario}?
                            </p>
                            <div className="flex items-center justify-end space-x-4">
                                <button
                                    onClick={() => setIsExportModalOpen(false)}
                                    className="px-6 py-3 border border-gray-300 rounded-2xl text-sm font-semibold text-gray-700 bg-white hover:bg-gray-50"
                                >
                                    Cancelar
                                </button>
                                <button
                                    onClick={confirmarExportacaoMovimentacoes}
                                    disabled={states.isLoading}
                                    className="px-6 py-3 border border-transparent rounded-2xl text-sm font-semibold text-white bg-gradient-to-r from-emerald-600 to-teal-700 hover:from-emerald-700 hover:to-teal-800 disabled:opacity-50"
                                >
                                    Enviar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal de Confirmação */}
            {isConfirmModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center p-4 z-50">
                    <div className="relative bg-white rounded-3xl shadow-2xl max-w-md w-full">
                        {/* Header do Modal */}
                        <div className={`relative rounded-t-3xl p-6 ${confirmAction === 'cancel'
                            ? 'bg-gradient-to-r from-red-600 via-red-700 to-red-700'
                            : 'bg-gradient-to-r from-blue-600 via-blue-700 to-blue-700'
                            }`}>
                            <div className="absolute inset-0 bg-gradient-to-r from-red-500/10 to-red-500/10 rounded-t-3xl"></div>
                            <div className="relative flex items-center justify-between">
                                <div className="flex items-center">
                                    <div className="p-3 rounded-2xl bg-white/20 backdrop-blur-sm mr-4">
                                        {confirmIcon && <confirmIcon className="w-8 h-8 text-white" />}
                                    </div>
                                    <div>
                                        <h2 className="text-2xl font-bold text-white">
                                            {confirmTitle}
                                        </h2>
                                        <p className="text-white/80 mt-1">
                                            Confirme sua ação
                                        </p>
                                    </div>
                                </div>
                                <button
                                    onClick={closeConfirmModal}
                                    className="p-2 rounded-full bg-white/20 backdrop-blur-sm text-white hover:bg-white/30 transition-colors duration-200"
                                >
                                    <XMarkIcon className="w-6 h-6" />
                                </button>
                            </div>
                        </div>

                        {/* Conteúdo do Modal */}
                        <div className="p-6">
                            <div className="text-center">
                                <div className={`mx-auto flex items-center justify-center h-12 w-12 rounded-full ${confirmAction === 'cancel'
                                    ? 'bg-red-100 text-red-600'
                                    : 'bg-blue-100 text-blue-600'
                                    } mb-4`}>
                                    {confirmIcon && <confirmIcon className="w-6 h-6" />}
                                </div>
                                <h3 className="text-lg font-medium text-gray-900 mb-2">
                                    {confirmTitle}
                                </h3>
                                <p className="text-sm text-gray-500 mb-6">
                                    {confirmMessage}
                                </p>
                            </div>

                            {/* Botões */}
                            <div className="flex items-center justify-end space-x-4">
                                <button
                                    onClick={closeConfirmModal}
                                    className="px-6 py-3 border border-gray-300 rounded-2xl text-sm font-semibold text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-all duration-300"
                                >
                                    Cancelar
                                </button>
                                <button
                                    onClick={handleConfirmAction}
                                    className={`px-6 py-3 border border-transparent rounded-2xl text-sm font-semibold text-white ${confirmButtonColor} focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-all duration-300 transform hover:scale-105`}
                                >
                                    {confirmButtonText}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}


            {/* Modal de Retorno para Estoque */}
            {isReturnModalOpen && returnMovimentacao && (
                <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center p-4 z-50">
                    <div className="relative bg-white rounded-3xl shadow-2xl max-w-7xl w-full max-h-[95vh] overflow-y-auto">
                        {/* Header do Modal */}
                        <div className="relative bg-gradient-to-r from-green-600 via-green-700 to-green-700 rounded-t-3xl p-6">
                            <div className="absolute inset-0 bg-gradient-to-r from-green-500/10 to-green-500/10 rounded-t-3xl"></div>
                            <div className="relative flex items-center justify-between">
                                <div className="flex items-center">
                                    <div className="p-3 rounded-2xl bg-white/20 backdrop-blur-sm mr-4">
                                        <ArchiveBoxIcon className="w-8 h-8 text-white" />
                                    </div>
                                    <div>
                                        <h2 className="text-2xl font-bold text-white">
                                            Retornar para Estoque
                                        </h2>
                                        <p className="text-green-100 mt-1">
                                            Retorne o produto "{returnMovimentacao?.produto_modelo}" do cliente "{returnMovimentacao?.entidade_destino_nome}" para o estoque
                                        </p>
                                    </div>
                                </div>
                                <button
                                    onClick={closeReturnModal}
                                    className="p-2 rounded-full bg-white/20 backdrop-blur-sm text-white hover:bg-white/30 transition-colors duration-200"
                                >
                                    <XMarkIcon className="w-6 h-6" />
                                </button>
                            </div>
                        </div>

                        {/* Conteúdo do Modal */}
                        <div className="p-8">
                            {loadingReturnData ? (
                                <div className="flex items-center justify-center py-20">
                                    <div className="text-center">
                                        <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-green-600 mx-auto"></div>
                                        <p className="mt-6 text-lg text-gray-600 font-medium">Carregando detalhes da movimentação...</p>
                                    </div>
                                </div>
                            ) : (
                                <div className="space-y-8">
                                    {/* Header com informações principais */}

                                    {/* Formulário de Retorno */}
                                    <div className="bg-gradient-to-r from-green-50 via-emerald-50 to-green-50 rounded-3xl p-8 border border-green-200">
                                        <div className="flex items-center mb-6">
                                            <div className="p-4 rounded-2xl bg-gradient-to-r from-green-500 to-emerald-600 shadow-lg mr-4">
                                                <ArchiveBoxIcon className="w-8 h-8 text-white" />
                                            </div>
                                            <div>
                                                <h3 className="text-2xl font-bold text-gray-900">Retorno para Estoque</h3>
                                                <p className="text-gray-600 mt-1">Preencha os dados para retornar o produto ao estoque</p>
                                            </div>
                                        </div>

                                        {/* Grid responsivo para campos do formulário */}
                                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                                            {/* Localização */}
                                            <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100">
                                                <div className="flex items-center mb-4">
                                                    <div className="p-2 rounded-xl bg-green-100 text-green-700 mr-3">
                                                        <MapPinIcon className="w-5 h-5" />
                                                    </div>
                                                    <h4 className="text-lg font-semibold text-gray-900">Nova Localização</h4>
                                                </div>
                                                <div className="space-y-4">
                                                    <div>
                                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                                            Localização *
                                                        </label>
                                                        <select
                                                            value={returnLocalizacaoId}
                                                            onChange={(e) => {
                                                                setReturnLocalizacaoId(e.target.value)
                                                                loadReturnDepartamentos(e.target.value)
                                                            }}
                                                            disabled={loadingReturnLocalizacoes}
                                                            className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-300 disabled:bg-gray-100 disabled:cursor-not-allowed"
                                                        >
                                                            <option value="">
                                                                {loadingReturnLocalizacoes ? 'Carregando localizações...' : 'Selecione uma localização'}
                                                            </option>
                                                            {!loadingReturnLocalizacoes && Array.isArray(returnLocalizacoes) && returnLocalizacoes.map((localizacao) => (
                                                                <option key={localizacao.id} value={localizacao.id}>
                                                                    {localizacao.nome}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div>
                                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                                            Departamento *
                                                        </label>
                                                        <select
                                                            value={returnDepartamentoId}
                                                            onChange={(e) => setReturnDepartamentoId(e.target.value)}
                                                            disabled={loadingReturnDepartamentos || !returnLocalizacaoId}
                                                            className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-300 disabled:bg-gray-100 disabled:cursor-not-allowed"
                                                        >
                                                            <option value="">
                                                                {loadingReturnDepartamentos ? 'Carregando departamentos...' : !returnLocalizacaoId ? 'Selecione primeiro uma localização' : 'Selecione um departamento'}
                                                            </option>
                                                            {!loadingReturnDepartamentos && Array.isArray(returnDepartamentos) && returnDepartamentos.map((departamento) => (
                                                                <option key={departamento.id} value={departamento.id}>
                                                                    {departamento.nome}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Observação */}
                                            <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100">
                                                <div className="flex items-center mb-4">
                                                    <div className="p-2 rounded-xl bg-yellow-100 text-yellow-700 mr-3">
                                                        <InformationCircleIcon className="w-5 h-5" />
                                                    </div>
                                                    <h4 className="text-lg font-semibold text-gray-900">Observação</h4>
                                                </div>
                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                                        Observação do Retorno *
                                                    </label>
                                                    <textarea
                                                        value={returnObservacao}
                                                        onChange={(e) => setReturnObservacao(e.target.value)}
                                                        rows={4}
                                                        placeholder="Digite uma observação sobre o retorno do produto..."
                                                        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-300 resize-none"
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {/* Upload de Imagens */}
                                        <div className="mt-8">
                                            <div className="flex items-center mb-6">
                                                <div className="p-3 rounded-xl bg-purple-100 text-purple-700 mr-3">
                                                    <PhotoIcon className="w-6 h-6" />
                                                </div>
                                                <div>
                                                    <h4 className="text-xl font-semibold text-gray-900">Imagens do Retorno</h4>
                                                    <p className="text-gray-600 text-sm">Adicione fotos do produto no momento do retorno</p>
                                                </div>
                                            </div>
                                            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                                                {/* Foto 1 */}
                                                <div className="bg-white rounded-2xl p-4 shadow-sm border border-gray-100">
                                                    <label className="block text-sm font-medium text-gray-700 mb-3">Foto 1</label>
                                                    <div className="relative">
                                                        {returnPreviewFoto1 ? (
                                                            <div className="relative">
                                                                <img
                                                                    src={returnPreviewFoto1}
                                                                    alt="Preview"
                                                                    className="w-full h-40 cursor-zoom-in object-cover rounded-xl"
                                                                    onDoubleClick={() => openImageModal(returnPreviewFoto1, 'Retorno — Foto 1')}
                                                                    title="Duplo clique para ampliar"
                                                                />
                                                                <button
                                                                    type="button"
                                                                    onClick={() => handleRemoveImage(setReturnFoto1, setReturnPreviewFoto1)}
                                                                    className="absolute top-2 right-2 bg-red-500 text-white rounded-full p-2 hover:bg-red-600 transition-colors duration-200"
                                                                >
                                                                    <XMarkIcon className="w-4 h-4" />
                                                                </button>
                                                            </div>
                                                        ) : (
                                                            <div className="flex flex-col items-center justify-center w-full h-40 border-2 border-gray-300 border-dashed rounded-xl hover:bg-gray-50 transition-all duration-200 px-2 py-2">
                                                                <PhotoIcon className="w-10 h-10 text-gray-400 mb-2" />
                                                                <p className="text-sm text-gray-500 font-medium mb-2">Adicionar foto</p>
                                                                <div className="flex flex-wrap gap-2 justify-center">
                                                                    <label htmlFor="mov-ret-f1-gal" className="cursor-pointer rounded-lg bg-gray-100 px-2 py-1 text-xs font-medium text-gray-700 hover:bg-gray-200">Galeria</label>
                                                                    <label htmlFor="mov-ret-f1-cam" className="cursor-pointer rounded-lg bg-blue-100 px-2 py-1 text-xs font-medium text-blue-800 hover:bg-blue-200">Câmera</label>
                                                                </div>
                                                                <input
                                                                    id="mov-ret-f1-gal"
                                                                    type="file"
                                                                    accept="image/*"
                                                                    onChange={(e) => {
                                                                        const f = e.target.files?.[0]
                                                                        if (f) handleImageUpload(f, setReturnFoto1, setReturnPreviewFoto1)
                                                                        e.target.value = ''
                                                                    }}
                                                                    className="hidden"
                                                                />
                                                                <input
                                                                    id="mov-ret-f1-cam"
                                                                    type="file"
                                                                    accept="image/*"
                                                                    capture="environment"
                                                                    onChange={(e) => {
                                                                        const f = e.target.files?.[0]
                                                                        if (f) handleImageUpload(f, setReturnFoto1, setReturnPreviewFoto1)
                                                                        e.target.value = ''
                                                                    }}
                                                                    className="hidden"
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>

                                                {/* Foto 2 */}
                                                <div className="bg-white rounded-2xl p-4 shadow-sm border border-gray-100">
                                                    <label className="block text-sm font-medium text-gray-700 mb-3">Foto 2</label>
                                                    <div className="relative">
                                                        {returnPreviewFoto2 ? (
                                                            <div className="relative">
                                                                <img
                                                                    src={returnPreviewFoto2}
                                                                    alt="Preview"
                                                                    className="w-full h-40 cursor-zoom-in object-cover rounded-xl"
                                                                    onDoubleClick={() => openImageModal(returnPreviewFoto2, 'Retorno — Foto 2')}
                                                                    title="Duplo clique para ampliar"
                                                                />
                                                                <button
                                                                    type="button"
                                                                    onClick={() => handleRemoveImage(setReturnFoto2, setReturnPreviewFoto2)}
                                                                    className="absolute top-2 right-2 bg-red-500 text-white rounded-full p-2 hover:bg-red-600 transition-colors duration-200"
                                                                >
                                                                    <XMarkIcon className="w-4 h-4" />
                                                                </button>
                                                            </div>
                                                        ) : (
                                                            <div className="flex flex-col items-center justify-center w-full h-40 border-2 border-gray-300 border-dashed rounded-xl hover:bg-gray-50 transition-all duration-200 px-2 py-2">
                                                                <PhotoIcon className="w-10 h-10 text-gray-400 mb-2" />
                                                                <p className="text-sm text-gray-500 font-medium mb-2">Adicionar foto</p>
                                                                <div className="flex flex-wrap gap-2 justify-center">
                                                                    <label htmlFor="mov-ret-f2-gal" className="cursor-pointer rounded-lg bg-gray-100 px-2 py-1 text-xs font-medium text-gray-700 hover:bg-gray-200">Galeria</label>
                                                                    <label htmlFor="mov-ret-f2-cam" className="cursor-pointer rounded-lg bg-blue-100 px-2 py-1 text-xs font-medium text-blue-800 hover:bg-blue-200">Câmera</label>
                                                                </div>
                                                                <input
                                                                    id="mov-ret-f2-gal"
                                                                    type="file"
                                                                    accept="image/*"
                                                                    onChange={(e) => {
                                                                        const f = e.target.files?.[0]
                                                                        if (f) handleImageUpload(f, setReturnFoto2, setReturnPreviewFoto2)
                                                                        e.target.value = ''
                                                                    }}
                                                                    className="hidden"
                                                                />
                                                                <input
                                                                    id="mov-ret-f2-cam"
                                                                    type="file"
                                                                    accept="image/*"
                                                                    capture="environment"
                                                                    onChange={(e) => {
                                                                        const f = e.target.files?.[0]
                                                                        if (f) handleImageUpload(f, setReturnFoto2, setReturnPreviewFoto2)
                                                                        e.target.value = ''
                                                                    }}
                                                                    className="hidden"
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>

                                                {/* Foto 3 */}
                                                <div className="bg-white rounded-2xl p-4 shadow-sm border border-gray-100">
                                                    <label className="block text-sm font-medium text-gray-700 mb-3">Foto 3</label>
                                                    <div className="relative">
                                                        {returnPreviewFoto3 ? (
                                                            <div className="relative">
                                                                <img
                                                                    src={returnPreviewFoto3}
                                                                    alt="Preview"
                                                                    className="w-full h-40 cursor-zoom-in object-cover rounded-xl"
                                                                    onDoubleClick={() => openImageModal(returnPreviewFoto3, 'Retorno — Foto 3')}
                                                                    title="Duplo clique para ampliar"
                                                                />
                                                                <button
                                                                    type="button"
                                                                    onClick={() => handleRemoveImage(setReturnFoto3, setReturnPreviewFoto3)}
                                                                    className="absolute top-2 right-2 bg-red-500 text-white rounded-full p-2 hover:bg-red-600 transition-colors duration-200"
                                                                >
                                                                    <XMarkIcon className="w-4 h-4" />
                                                                </button>
                                                            </div>
                                                        ) : (
                                                            <div className="flex flex-col items-center justify-center w-full h-40 border-2 border-gray-300 border-dashed rounded-xl hover:bg-gray-50 transition-all duration-200 px-2 py-2">
                                                                <PhotoIcon className="w-10 h-10 text-gray-400 mb-2" />
                                                                <p className="text-sm text-gray-500 font-medium mb-2">Adicionar foto</p>
                                                                <div className="flex flex-wrap gap-2 justify-center">
                                                                    <label htmlFor="mov-ret-f3-gal" className="cursor-pointer rounded-lg bg-gray-100 px-2 py-1 text-xs font-medium text-gray-700 hover:bg-gray-200">Galeria</label>
                                                                    <label htmlFor="mov-ret-f3-cam" className="cursor-pointer rounded-lg bg-blue-100 px-2 py-1 text-xs font-medium text-blue-800 hover:bg-blue-200">Câmera</label>
                                                                </div>
                                                                <input
                                                                    id="mov-ret-f3-gal"
                                                                    type="file"
                                                                    accept="image/*"
                                                                    onChange={(e) => {
                                                                        const f = e.target.files?.[0]
                                                                        if (f) handleImageUpload(f, setReturnFoto3, setReturnPreviewFoto3)
                                                                        e.target.value = ''
                                                                    }}
                                                                    className="hidden"
                                                                />
                                                                <input
                                                                    id="mov-ret-f3-cam"
                                                                    type="file"
                                                                    accept="image/*"
                                                                    capture="environment"
                                                                    onChange={(e) => {
                                                                        const f = e.target.files?.[0]
                                                                        if (f) handleImageUpload(f, setReturnFoto3, setReturnPreviewFoto3)
                                                                        e.target.value = ''
                                                                    }}
                                                                    className="hidden"
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Botões */}
                                        <div className="flex items-center justify-end space-x-4 mt-8 pt-6 border-t border-gray-200">
                                            <button
                                                onClick={closeReturnModal}
                                                className="px-8 py-3 border border-gray-300 rounded-xl text-sm font-semibold text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-all duration-300"
                                            >
                                                Cancelar
                                            </button>
                                            <button
                                                onClick={handleReturnToStock}
                                                disabled={isSubmittingReturn}
                                                className="group relative inline-flex items-center px-8 py-3 border border-transparent rounded-xl shadow-lg text-sm font-semibold text-white bg-gradient-to-r from-green-600 via-green-700 to-green-700 hover:from-green-700 hover:via-green-800 hover:to-green-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-all duration-300 transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed"
                                            >
                                                <div className="relative z-10 flex items-center">
                                                    {isSubmittingReturn ? (
                                                        <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mr-3"></div>
                                                    ) : (
                                                        <ArchiveBoxIcon className="w-5 h-5 mr-3" />
                                                    )}
                                                    <span className="text-base font-medium">{isSubmittingReturn ? 'Retornando...' : 'Retornar para Estoque'}</span>
                                                </div>
                                                <div className="absolute inset-0 bg-gradient-to-r from-green-500/10 to-green-500/10 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}

            <ZoomableImageModal
                isOpen={isImageModalOpen}
                onClose={closeImageModal}
                src={expandedImage}
                alt={expandedImageAlt}
            />
        </div>
    )
}

export default Movimentacoes
